var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4266.6665 2666.6667",
    height: 2666.6667,
    width: 4266.6665,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,2666.6667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.96319)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#ffffff",
      fillOpacity: 0,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 16300,0 H 0 V 10187.5 H 16300 V 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.89751)",
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#d2e3fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16189.8,3382.59 c -13.4,-118.94 -31.9,-235.57 -55.9,-348.56 -20,-94.86 -43.9,-187.09 -71.8,-276.05 -5.8,-18.76 -11.8,-37.41 -18.2,-55.86 -92.4,-273.94 -223.8,-513.3 -398.6,-693.75 -1.8,-1.9 -3.6,-3.8 -5.5,-5.69 l -156,-2.11 -766.9,-10.22 -1620.6,-21.66 -1324.6,-9.17 -66.8,0.26 -2541.25,9.49 -7607.35,21.08 -271.69,0.73 c 0,0 -183.57,282.53 -361.247,713.52 -7.52,18.29 -15.04,36.78 -22.509,55.55 -74.055,185.71 -145.68,396.46 -200.868,622.44 C 569.114,3917.98 530.121,4538.9 768.197,5114.49 1237.05,6248.06 1842.16,6615.96 2565.4,6811.45 l 17.36,4.63 c 635.48,168.99 1361.5,209.2 2165.85,520.05 410.25,158.53 694.26,335.04 975.47,505.82 5.8,3.54 11.6,7.07 17.39,10.59 207.8,126.01 415.39,248.56 672.62,358.07 38.42,16.43 77.1,32.11 115.94,47.15 l 0.06,0.06 c 60.23,23.37 121.05,45.19 182.18,65.43 30.99,10.3 62.14,20.19 93.39,29.63 0.95,0.29 1.95,0.58 2.95,0.92 l 0.05,0.06 c 30.99,9.37 62.14,18.34 93.34,26.84 l 0.05,0.06 c 370.38,102 753.72,148.45 1136.22,139.67 786.46,-18.06 1569.27,-269.95 2227.93,-754.14 5.8,-4.23 11.6,-8.51 17.4,-12.85 23.5,-17.47 47,-35.29 70.2,-53.4 12.5,-9.78 25,-19.67 37.5,-29.62 18.6,-14.93 37.2,-29.45 55.9,-43.68 1,-0.81 2,-1.62 3,-2.38 10,-7.68 20.1,-15.27 30.1,-22.79 5.8,-4.34 11.6,-8.62 17.4,-12.9 12.5,-9.26 25.1,-18.34 37.6,-27.3 2.7,-1.98 5.5,-3.94 8.3,-5.85 29.3,-21 58.7,-41.14 88.1,-60.58 18.6,-12.38 37.3,-24.41 56,-36.21 4,-2.49 8,-5.03 12,-7.47 18.3,-11.51 36.7,-22.73 55.1,-33.66 11.5,-6.95 23.2,-13.72 34.8,-20.43 2.4,-1.33 4.8,-2.78 7.1,-4.11 38.8,-22.22 77.5,-43.21 116,-63 117.8,-60.58 234.9,-110.5 351.5,-151.52 5.8,-2.09 11.5,-4.11 17.3,-6.08 65.8,-22.68 131.4,-42.58 196.8,-59.99 l 17.3,-4.58 c 299,-77.69 593.8,-104.31 885.2,-110.96 5.8,-0.12 11.6,-0.23 17.3,-0.35 29,-0.58 58,-0.98 86.8,-1.21 l 17.4,-0.18 c 145.9,-0.84 290.8,2.26 435,5.36 439.3,9.46 870.6,18.9 1294.8,-83.34 5.8,-1.4 11.6,-2.78 17.4,-4.23 29,-7.17 57.9,-14.93 86.8,-23.2 5.8,-1.62 11.6,-3.3 17.4,-5.03 142.1,-41.89 283.5,-97.6 424.1,-171.43 49.6,-25.92 99,-54.15 148.2,-84.81 222.3,-138.04 442.8,-325.38 661.5,-578.9 468.7,-543.25 712.5,-1683.94 602.3,-2667.02"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.89751)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#e6f1ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16189.8,3382.59 c -13.4,-118.94 -31.9,-235.57 -55.9,-348.56 -20,-94.86 -43.9,-187.09 -71.8,-276.05 -5.8,-18.76 -11.8,-37.41 -18.2,-55.86 -92.4,-273.94 -223.8,-513.3 -398.6,-693.75 H 14496.7 V 5935.4 c 0,295.88 105.6,567.04 281.1,777.92 49.6,-25.92 99,-54.15 148.2,-84.81 222.3,-138.04 442.8,-325.38 661.5,-578.9 468.7,-543.25 712.5,-1683.94 602.3,-2667.02"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.68764)",
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#c8dcf9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16120.1,2237.86 h -5317.4 v 1565.38 h 5496.8 V 2258.13 h 0.5 v -17.66 l -179.9,-2.61 m -1330.7,1414.35 c 0,-94.75 -76.9,-171.61 -171.6,-171.61 v -851.24 c 94.7,0 171.6,-76.86 171.6,-171.67 h 1067.5 c 0,94.81 76.8,171.67 171.6,171.67 v 851.24 c -94.8,0 -171.6,76.86 -171.6,171.61 h -1067.5 m -1560.1,0 c 0,-94.75 -76.8,-171.61 -171.6,-171.61 v -851.24 c 94.8,0 171.6,-76.86 171.6,-171.67 h 1067.5 c 0,94.81 76.8,171.67 171.6,171.67 v 851.24 c -94.8,0 -171.6,76.86 -171.6,171.61 h -1067.5 m -1580.7,0 c 0,-94.75 -76.9,-171.61 -171.6,-171.61 v -851.24 c 94.7,0 171.6,-76.86 171.6,-171.67 h 1067.5 c 0,94.81 76.9,171.67 171.6,171.67 v 851.24 c -94.7,0 -171.6,76.86 -171.6,171.61 h -1067.5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.68764)",
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#d8e7fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,2258.13 h -0.5 v 1545.11 h 0.5 V 2258.13"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.82129)",
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#d2e3fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15226.2,2084.29 v 8.12 H 16300 v 0 l -1073.8,-8.12"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.88775)",
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#e0edfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15726.2,2018.75 v 0 h -1036 v 3873.61 c 0,299.66 119.3,571.36 313,770.42 223.5,-138.75 445,-327.06 664.9,-581.89 395.6,-458.61 631.9,-1340.8 631.7,-2196.95 0,-163.26 -8.6,-325.57 -26.3,-483.86 -13.4,-119.56 -32,-236.79 -56.1,-350.36 -20.2,-95.35 -44.2,-188.06 -72.2,-277.48 -5.9,-18.85 -12,-37.61 -18.3,-56.15 v 0 c -32.6,-96.51 -70,-188.74 -112.4,-275.72 -78.5,-161.09 -174.3,-303.8 -288.3,-421.62 v 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#ecf2fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2437.55,3778.1 v 0 0 m -0.01,0 c -1.98,3.1 -310.12,478 -626.7,1214.4 316.62,-736.4 624.71,-1211.3 626.7,-1214.4 m -695.16,1377.6 c -49.53,121.1 -98.78,248.3 -146.53,380.6 37.14,-102.9 75.16,-202.7 113.53,-298.9 10.95,-27.5 21.97,-54.7 33,-81.7 M 1595.6,5537 c -0.26,0.7 -0.56,1.6 -0.82,2.3 0.27,-0.8 0.55,-1.5 0.82,-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#c8dcf9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 13577.4,3776.7 H 2953.09 l -515.54,1.4 v 0 0 0 h -0.01 c -1.99,3.1 -310.08,478 -626.7,1214.4 -22.83,53.1 -45.66,107.5 -68.46,163.2 -11.03,27 -22.05,54.2 -33,81.7 -38.37,96.2 -76.39,196 -113.53,298.9 -0.09,0.3 -0.17,0.5 -0.25,0.7 -0.27,0.8 -0.55,1.5 -0.82,2.3 -98.47,273.2 -190.65,568.6 -266.55,879.2 H 13577.4 V 3776.7 m -2839.3,2386.9 c 0,-159.9 -129.7,-289.6 -289.7,-289.6 V 4437.4 c 160,0 289.7,-129.7 289.7,-289.7 h 1801.5 c 0,160 129.7,289.7 289.7,289.7 V 5874 c -160,0 -289.7,129.7 -289.7,289.6 h -1801.5 m -2667.65,0 c 0,-159.9 -129.68,-289.6 -289.66,-289.6 V 4437.4 c 159.98,0 289.66,-129.7 289.66,-289.7 h 1801.57 c 0,160 129.68,289.7 289.68,289.7 V 5874 c -160,0 -289.68,129.7 -289.68,289.6 H 8070.45 m -2632.87,0 c 0,-159.9 -129.68,-289.6 -289.66,-289.6 V 4437.4 c 159.98,0 289.66,-129.7 289.66,-289.7 h 1801.57 c 0,160 129.68,289.7 289.65,289.7 V 5874 c -159.97,0 -289.65,129.7 -289.65,289.6 H 5437.58 m -2667.63,0 c 0,-159.9 -129.69,-289.6 -289.67,-289.6 V 4437.4 c 159.98,0 289.67,-129.7 289.67,-289.7 h 1801.56 c 0,160 129.68,289.7 289.66,289.7 V 5874 c -159.98,0 -289.66,129.7 -289.66,289.6 H 2769.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#b7d0f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 4571.51,4147.7 H 2769.95 c 0,160 -129.69,289.7 -289.67,289.7 V 5874 c 159.98,0 289.67,129.7 289.67,289.6 h 1801.56 c 0,-159.9 129.68,-289.6 289.66,-289.6 V 4437.4 c -159.98,0 -289.66,-129.7 -289.66,-289.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#b7d0f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 7239.15,4147.7 H 5437.58 c 0,160 -129.68,289.7 -289.66,289.7 V 5874 c 159.98,0 289.66,129.7 289.66,289.6 h 1801.57 c 0,-159.9 129.68,-289.6 289.65,-289.6 V 4437.4 c -159.97,0 -289.65,-129.7 -289.65,-289.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#b7d0f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 9872.02,4147.7 H 8070.45 c 0,160 -129.68,289.7 -289.66,289.7 V 5874 c 159.98,0 289.66,129.7 289.66,289.6 h 1801.57 c 0,-159.9 129.68,-289.6 289.68,-289.6 V 4437.4 c -160,0 -289.68,-129.7 -289.68,-289.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#b7d0f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12539.6,4147.7 h -1801.5 c 0,160 -129.7,289.7 -289.7,289.7 V 5874 c 160,0 289.7,129.7 289.7,289.6 h 1801.5 c 0,-159.9 129.7,-289.6 289.7,-289.6 V 4437.4 c -160,0 -289.7,-129.7 -289.7,-289.7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.33434)",
    id: "g54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#b7d0f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16083,3108.42 h -1350.2 c 0,119.91 -97.2,217.11 -217,217.11 v 1076.63 c 119.8,0 217,97.21 217,217.04 H 16083 c 0,-119.83 97.2,-217.04 217,-217.04 V 3325.53 c -119.8,0 -217,-97.2 -217,-217.11"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.49801)",
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#b7d0f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 16106.6,2768.81 H 14904 c 0,106.81 -86.6,193.4 -193.4,193.4 v 959 c 106.8,0 193.4,86.58 193.4,193.33 h 1202.6 c 0,-106.75 86.6,-193.33 193.4,-193.33 v -959 c -106.8,0 -193.4,-86.59 -193.4,-193.4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.65953)",
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#b7d0f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16125.5,2499.33 h -1085.6 c 0,96.41 -78.2,174.56 -174.5,174.56 v 865.67 c 96.3,0 174.5,78.16 174.5,174.51 h 1085.6 c 0,-96.35 78.1,-174.51 174.5,-174.51 v -865.67 c -96.4,0 -174.5,-78.15 -174.5,-174.56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#f99746",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8336.9,5126.7 c 436.94,0 905.27,12.6 1404.61,41.9 1280.99,75.2 2169.59,226.7 2178.49,228.2 l -13.1,104.7 c -8.8,-1.5 -894.1,-152.4 -2171.04,-227.3 -1177.91,-69 -2939.45,-85.7 -4642.48,227.3 l -13.94,-104.6 c 724.26,-133.1 1819.9,-270.2 3257.46,-270.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11970.9,3811.8 h 76.6 v 1808.3 h -76.6 V 3811.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12080.1,5683.1 c 0,46 -31.7,83.2 -70.9,83.2 -39.2,0 -70.9,-37.2 -70.9,-83.2 0,-46 31.7,-83.2 70.9,-83.2 39.2,0 70.9,37.2 70.9,83.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11942.1,3793.8 h 138 v 42.7 h -138 v -42.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11950.8,5599.9 h 115.9 v 34.6 h -115.9 v -34.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11751.5,5486.3 18.2,-124.8 162.2,31.1 -20.2,121.5 -160.2,-27.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11970.9,5431.9 -0.1,-0.1 c -4.6,-5.6 -10.9,-9.3 -17.9,-10.7 l -25,-4.4 -10.2,-1.9 h -0.1 l -40.1,-7.3 c -17.8,-3.2 -34.5,11.2 -37.2,32.1 -1.3,10.1 0.8,20.2 6,28.5 5.1,8.3 12.7,13.8 21.3,15.2 l 40.6,7.3 7.2,1.4 h 0.1 l 27.5,4.9 c 8.6,1.6 17.2,-0.8 24.3,-7 1.2,-1.1 2.4,-2.3 3.5,-3.6 l 0.1,-0.1 c 5,-5.6 8.3,-13.1 9.4,-21.3 1.6,-12.8 -2.2,-24.7 -9.4,-33 z m 19.3,34.7 c -1.8,13.2 -7.8,24.8 -16.9,32.7 l -2.4,1.9 -0.1,0.1 c -8.8,6.6 -19.1,9.1 -29.4,7.3 l -27.9,-5.1 -47.4,-8.4 -2.7,-0.7 h -0.1 -0.2 l -1.1,-0.3 c -9.6,-3 -17.8,-9.6 -23.8,-19 -6.8,-10.8 -9.5,-24.2 -7.8,-37.2 3.1,-24.8 21.4,-42.7 42.2,-42.7 2.2,0 4.4,0.3 6.5,0.7 l 40.1,7.2 10.6,1.8 24.6,4.4 c 6.1,1.1 11.7,3.8 16.4,7.4 l 0.1,0.1 c 13.8,10.3 21.9,29.5 19.3,49.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#f99746",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4839.31,5396.8 c -2.09,-0.4 -55.03,-9.4 -151.88,-23.8 h -0.1 c -306.65,-46.1 -1053.35,-147.3 -2026.52,-204.4 -316.78,-18.6 -621.14,-30.4 -912.79,-36.6 -12.91,34.7 -25.82,69.8 -38.64,105.4 343.3,6.6 661.47,20.2 945.77,36.9 967.31,56.6 1709.94,157.1 2016.98,203.1 46.79,6.9 83.44,12.7 109.17,16.7 l 1.39,0.3 c 27.61,4.4 42.31,6.9 43.51,7.1 l 1.39,-10.9 9.33,-75.8 1.49,-11.7 0.9,-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4670.81,5486.3 18.2,-124.8 162.2,31.1 -20.15,121.5 -160.25,-27.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4890.46,5432.1 c -4.76,-5.8 -11.02,-9.6 -18.17,-11 l -25.03,-4.4 h -0.1 l -10.24,-1.9 -40.13,-7.3 c -17.78,-3.2 -34.47,11.2 -37.25,32.1 -1.19,10.1 0.9,20.2 6.06,28.5 5.17,8.3 12.72,13.8 21.36,15.2 l 40.63,7.3 7.15,1.4 27.61,4.9 c 8.55,1.6 17.19,-0.8 24.24,-7 1.39,-1.2 2.68,-2.4 3.87,-3.8 4.77,-5.7 8.05,-13.2 9.14,-21.2 1.59,-12.7 -2.08,-24.6 -9.14,-32.8 z m 19.08,34.5 c -1.79,13.2 -7.75,24.8 -17.09,32.7 l -1.99,1.7 c -8.74,6.8 -19.26,9.4 -29.69,7.6 l -27.92,-5.1 -47.38,-8.4 -2.78,-0.7 -1.39,-0.3 c -9.54,-3 -17.78,-9.6 -23.75,-19 -6.85,-10.8 -9.53,-24.2 -7.84,-37.2 3.18,-24.8 21.46,-42.7 42.21,-42.7 2.19,0 4.38,0.3 6.56,0.7 l 39.93,7.2 10.73,1.8 24.64,4.4 c 6.06,1.1 11.72,3.8 16.68,7.5 13.62,10.4 21.66,29.7 19.08,49.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5169.46,5371 14.07,125.6 -162.79,26.6 -11.37,-123.1 160.09,-29.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5096.48,5446.5 c -1.39,-10.2 -5.85,-19.1 -13.01,-25.1 l -0.79,-0.7 -0.1,-0.1 c -6.75,-5.6 -15.1,-8 -23.35,-6.6 l -47.77,8.5 h -0.1 l -27.62,4.8 c -6.16,1.1 -12.02,4.3 -16.59,9.3 -1.79,1.7 -3.38,3.7 -4.77,5.9 -5.16,8.3 -7.35,18.4 -6.06,28.4 1.1,9.3 5.17,17.5 10.83,23.1 6.85,7.3 16.39,11.1 26.33,9.3 l 25.03,-4.3 50.36,-8.9 c 8.74,-1.5 16.09,-6.9 21.06,-14.5 5.27,-7.9 7.95,-18.3 6.55,-29.1 z m -4.57,43.7 c -4.37,4.4 -9.43,7.8 -15.09,9.9 -2.09,0.7 -4.28,1.3 -6.46,1.8 l -50.86,8.6 -24.53,4.4 c -10.04,1.8 -19.67,-0.6 -27.82,-6.3 -10.83,-7.3 -18.77,-20.2 -20.76,-35.9 -1.69,-13.2 1.19,-26.5 7.95,-37.2 3.47,-5.6 7.85,-10.1 12.81,-13.5 4.67,-3.3 9.84,-5.3 15.3,-6.3 l 27.91,-4.8 47.49,-8.4 c 7.84,-1.4 15.59,-0.1 22.74,3.4 3.08,1.5 6.06,3.4 8.84,6 9.24,8 15.3,19.6 16.89,32.9 2.28,17.7 -3.67,34.6 -14.41,45.4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.11815)",
    id: "g90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#e6f1ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14235.1,12137.4 v 0 c -1140.5,0 -2064.9,-924.5 -2064.9,-2065 V 3408.21 H 16300 v 6664.19 c 0,1140.5 -924.5,2065 -2064.9,2065"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.83942)",
    id: "g94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,3581.56 h -1011.9 v 162 H 16300 v -162"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.85469)",
    id: "g98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path100",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,2483.87 c -80,-163.96 -177.4,-309.22 -293.5,-429.13 h 293.5 v -1.24 H 15028.2 V 3553.21 H 16300 V 2483.87"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.80873)",
    id: "g102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,3195.45 h -475.8 v 188.09 h 475.8 v -188.09"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.82848)",
    id: "g106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#afd1f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15561.9,3766.4 c 0,0 10,82.91 79.4,111.73 69.5,28.88 499.9,98.17 499.9,98.17 0,0 156.7,-108.62 158.8,-211.98 0,0 -738.1,-2.08 -738.1,2.08"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.81362)",
    id: "g110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15751.6,3151.43 h 534.3 v 258.38 h -534.3 z m 548.4,-14 h -562.4 v 286.39 h 562.4 v -286.39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.81067)",
    id: "g114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,4015.41 c 0,0 -319.9,-157.46 -504.8,-99.13 0,0 45.5,58.15 124.8,101.84 -4.5,26.89 -8.1,51.47 -11,73.39 -10.2,79.25 -10.6,124.38 -10.6,124.38 l 196,158 44,35.46 c -1.3,-37.5 1.1,-72.24 6,-104.27 0.4,-2.54 0.7,-5.03 1.2,-7.51 31.8,-190.21 154.4,-282.16 154.4,-282.16"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.7937)",
    id: "g118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,4341.14 c 0,0 -0.6,-1 -1.6,-2.9 -12.5,-22.41 -97.8,-166.64 -238.8,-208.01 -10.4,80.01 -10.8,125.56 -10.8,125.56 l 198,159.5 c 26.1,-30.61 43.9,-58.65 50.4,-69.47 1.8,-3.01 2.8,-4.68 2.8,-4.68"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.8066)",
    id: "g122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path124",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15877.6,4229.84 c 0,0 306.1,-50.87 334.8,140.21 28.8,191.13 87.6,313.24 -106.6,353.81 -194.2,40.52 -243.3,-26.68 -268.3,-88.12 -25.2,-61.44 -38.8,-387.75 40.1,-405.9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.82509)",
    id: "g126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15992.7,4374.54 c 0,0 40.2,40.65 17.1,66.24 -23.2,25.64 -36.6,-13.37 -54.9,-12.17 -18.3,1.21 -51.2,54.85 -53.7,103.61 -2.4,48.77 -175.9,109.75 -225.4,54.2 -1.2,-1.37 0.8,64.05 43.5,111.33 48,53.04 300.4,184.76 423.6,28.33 157.1,-199.44 -52.7,-408.42 -80.8,-440.09 -27.9,-31.73 -44,-22.35 -44,-22.35 0,0 -49.5,66.95 -25.4,110.9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.10443)",
    id: "g130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path132",
    style: {
      fill: "#d2e3fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,3437.16 h -3776.1 v 13.4 H 16300 v -13.4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.10443)",
    id: "g134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path136",
    style: {
      fill: "#e0edfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,3450.56 h -3776.1 v 6620.94 c 0,1042.7 845.4,1888.1 1888.1,1888.1 v 0 c 1042.7,0 1888,-845.4 1888,-1888.1 V 3450.56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.63318)",
    id: "g138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,2333.97 h -51.9 v 1107.22 h 51.9 V 2333.97"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.63539)",
    id: "g142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16204.2,3475.07 c 0,28.13 21.4,50.87 47.9,50.87 26.4,0 47.9,-22.74 47.9,-50.87 0,-28.13 -21.5,-50.88 -47.9,-50.88 -26.5,0 -47.9,22.75 -47.9,50.88"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.63513)",
    id: "g146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path148",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,2320.18 h -93.3 v 26.11 h 93.3 v -26.11"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.63455)",
    id: "g150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path152",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,3425.95 h -78.4 v 21.17 h 78.4 v -21.17"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.62037)",
    id: "g154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path156",
    style: {
      fill: "#f99746",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14078.3,3163.9 c -298,0 -617.5,7.78 -958.1,25.86 -873.6,46.41 -1479.7,139.9 -1485.7,140.83 l 8.9,64.61 c 6,-0.92 609.8,-94.05 1480.7,-140.27 803.4,-42.59 2004.9,-52.89 3166.4,140.27 l 9.5,-64.55 c -494,-82.14 -1241.3,-166.75 -2221.7,-166.75"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.15312)",
    id: "g158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,3305.63 h -73.5 v 1568.18 h 73.5 V 3305.63"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.15533)",
    id: "g162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path164",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16164.4,4919.02 c 0,39.82 30.4,72.02 67.8,72.02 37.5,0 67.8,-32.2 67.8,-72.02 0,-39.81 -30.3,-72.01 -67.8,-72.01 -37.4,0 -67.8,32.2 -67.8,72.01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.15507)",
    id: "g166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path168",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,3284.47 h -132 v 36.96 h 132 v -36.96"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.15449)",
    id: "g170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path172",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,4850.54 h -111 v 29.97 h 111 v -29.97"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.168)",
    id: "g174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path176",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,4697.17 -17.2,-106.85 -153.5,26.63 19.1,104.03 151.6,-23.81"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.16277)",
    id: "g178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path180",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16289,4678.15 c -2.7,-17.97 -18.4,-30.36 -35.4,-27.6 l -38.1,6.27 -9.8,1.64 -23.8,3.78 c -6.7,1.21 -12.5,4.39 -17.1,9.2 -6.9,7.14 -10.5,17.46 -8.9,28.47 1.1,7.05 4.1,13.59 8.9,18.41 1.1,1.11 2.2,2.15 3.4,3.09 6.8,5.33 15,7.4 23.1,6.02 l 26.2,-4.21 h 0.1 l 6.8,-1.21 38.6,-6.27 c 8.2,-1.21 15.4,-5.94 20.3,-13.08 4.9,-7.14 6.9,-15.82 5.7,-24.51 z m 2,30.53 c -5.7,8.09 -13.6,13.76 -22.6,16.34 l -1.2,0.26 h -0.1 -0.1 c -1,0.17 -1.7,0.52 -2.6,0.6 l -45,7.23 -26.6,4.38 c -9.8,1.55 -19.6,-0.6 -28,-6.27 l -2.2,-1.72 c -8.8,-6.8 -14.5,-16.78 -16.1,-28.13 -2.5,-17.46 5.1,-34.05 18.3,-42.91 4.6,-3.1 9.8,-5.42 15.7,-6.37 l 23.4,-3.78 10.1,-1.55 38.1,-6.19 c 2.1,-0.35 4.1,-0.6 6.2,-0.6 19.6,0 37,15.39 40.2,36.72 1.5,11.18 -1.1,22.7 -7.5,31.99"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.86982)",
    id: "g182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path184",
    style: {
      fill: "#f99746",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,2798.83 c -5.9,-19.04 -12,-37.97 -18.5,-56.69 -228.2,1.61 -470.5,8.5 -726.4,22.09 -575.2,30.54 -1016.6,84.66 -1197.8,109.31 h -0.1 c -57.3,7.71 -88.5,12.52 -89.8,12.73 l 0.5,3.37 0.9,6.26 5.5,40.54 0.9,5.83 c 0.7,-0.11 9.4,-1.45 25.7,-3.8 l 0.8,-0.16 c 15.2,-2.14 36.9,-5.24 64.6,-8.93 181.4,-24.6 620.4,-78.35 1192,-108.62 217.5,-11.55 468.6,-20.38 741.7,-21.93"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.64808)",
    id: "g186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path188",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,3328.9 -12.2,-75.72 -108.8,18.87 13.5,73.72 107.5,-16.87"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.64285)",
    id: "g190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path192",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16292.1,3311.08 c -1.8,-12.72 -13,-21.48 -25,-19.54 l -27,4.45 -6.9,1.15 -16.8,2.68 c -4.8,0.85 -9,3.17 -12.2,6.7 -4.8,4.99 -7.3,12.23 -6.2,19.96 0.8,4.87 2.9,9.44 6.2,12.91 0.8,0.85 1.6,1.58 2.5,2.31 4.8,3.77 10.6,5.23 16.4,4.26 l 18.5,-2.98 v 0 l 4.8,-0.85 27.4,-4.45 c 5.8,-0.85 10.9,-4.2 14.4,-9.25 3.5,-5.05 4.9,-11.2 3.9,-17.35 z m 1.4,21.61 c -3.9,5.72 -9.5,9.74 -15.9,11.57 l -0.9,0.18 c -0.7,0.12 -1.3,0.36 -1.9,0.43 l -31.9,5.11 -18.7,3.1 c -7.2,1.1 -14.2,-0.48 -20,-4.62 l -1.4,-1.04 c -6.3,-4.81 -10.4,-11.87 -11.5,-19.9 -1.8,-12.24 3.6,-23.99 12.9,-30.32 3.3,-2.25 7.1,-3.89 11.2,-4.56 l 16.5,-2.68 7.2,-1.09 26.9,-4.39 c 1.5,-0.24 3,-0.43 4.5,-0.43 13.9,0 26.2,10.9 28.3,26 1.2,7.91 -0.7,16.07 -5.3,22.64"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.62512)",
    id: "g194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path196",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16191.1,3304.98 -9.5,77.29 110.7,16.37 7.7,-75.75 -108.9,-17.91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.62951)",
    id: "g198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path200",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16288,3339.96 c -0.9,-1.35 -2.1,-2.57 -3.2,-3.62 -3.1,-3.07 -7.1,-5.03 -11.3,-5.7 l -18.8,-2.95 -32.4,-5.22 c -5.6,-0.86 -11.3,0.62 -15.9,4.11 l -0.5,0.44 c -4.9,3.68 -7.9,9.14 -8.8,15.4 -1,6.63 0.8,12.95 4.4,17.79 v 0.07 c 3.4,4.66 8.4,7.97 14.3,8.89 l 34.2,5.47 16.9,2.64 c 6.8,1.1 13.2,-1.23 17.9,-5.71 3.8,-3.44 6.5,-8.47 7.3,-14.18 0.9,-6.14 -0.6,-12.33 -4.1,-17.43 z m 10.8,18.54 c -1.3,9.63 -6.7,17.55 -14,22.03 -5.5,3.5 -12,4.97 -18.9,3.86 l -16.7,-2.7 -34.4,-5.28 c -1.5,-0.3 -3,-0.67 -4.4,-1.1 -3.8,-1.29 -7.2,-3.37 -10.2,-6.08 -7.3,-6.62 -11.4,-16.99 -9.9,-27.86 1.2,-8.16 5.3,-15.28 11.6,-20.19 1.8,-1.59 3.7,-2.76 5.9,-3.62 v -0.06 c 4.8,-2.14 10.2,-2.94 15.5,-2.08 l 32.2,5.15 18.9,2.95 c 3.7,0.61 7.2,1.84 10.4,3.86 3.4,2.09 6.3,4.85 8.7,8.29 4.5,6.56 6.5,14.73 5.3,22.83"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    style: {
      fill: "#b8d1f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7192.44,7156.6 h 1084.6 v 329.199 h -1084.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7122.19,7096.2 h 1225.1 v 450.1 h -1225.1 z m 1253.23,-28.1 H 7094.07 v 506.3 h 1281.35 v -506.3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.2888)",
    id: "g206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path208",
    style: {
      fill: "#b8d1f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,6089.55 h -841.6 v 255.44 h 841.6 v -255.44"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.29483)",
    id: "g210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path212",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15332.1,6014.52 h 946.2 v 347.53 h -946.2 z m 967.9,-21.78 h -989.6 v 391.09 h 989.6 v -391.09"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.56594)",
    id: "g214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path216",
    style: {
      fill: "#b8d1f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,5099.43 h -692.6 v 210.29 h 692.6 v -210.29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.57198)",
    id: "g218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path220",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15502.8,5041.43 h 779.3 v 286.33 h -779.3 z m 797.2,-17.88 h -815.1 v 322.08 h 815.1 v -322.08"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.33733)",
    id: "g222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path224",
    style: {
      fill: "#afcdfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 16300,9206.85 V 6367.38 H 14231.3 V 9206.85 H 16300"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.3152)",
    id: "g226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path228",
    style: {
      fill: "#8ab7f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15442.3,9037.95 c 0,0 183.7,33.38 388.2,-112.7 129,-92.19 191.3,-47.83 243.5,-186.95 52.1,-139.12 198.2,-222.59 156.4,-354.75 -41.7,-132.16 69.6,-97.39 38.3,-226.07 -31.3,-128.68 20.9,-191.29 7,-285.19 -13.9,-93.91 -333.9,-201.72 -483.5,-177.38 -149.5,24.35 -333.9,104.34 -281.7,313.02 52.2,208.68 -68.2,1030.02 -68.2,1030.02"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.28031)",
    id: "g230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fill: "#8ab7f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15544,9118.15 c 0,0 168.4,249.68 522.5,147.85 0,0 134.9,-55.99 183.7,-285.64 49.8,-234.32 -106,-412.43 -186.6,-368.41 -51.7,28.23 -90.8,-62.2 -90.8,-62.2 l -428.8,568.4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.28818)",
    id: "g234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path236",
    style: {
      fill: "#dcecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16274.8,7364.48 c -7.1,-48.29 -18.7,-96.03 -35.5,-142.38 -71.3,-196.86 -108,-277.13 -106.2,-351.58 1.5,-65.83 33.2,-127 97.8,-260.21 h -927.7 c 107.6,452.73 -31.2,604.89 -40.5,845.46 -0.9,21.5 -0.8,43.78 0.8,66.91 20.2,309.28 259.7,641.91 259.7,641.91 0,0 0.8,0.08 2.2,0.25 0.5,0 1.1,0.08 1.9,0.17 1.5,0.17 3.2,0.34 5,0.51 2.2,0.25 4.6,0.51 6.7,0.68 1.3,0.09 2.5,0.17 3.5,0.26 4,0.42 8.5,0.85 13.6,1.28 16,8.44 20.2,75.67 20.1,146.66 0,4.18 0,8.36 -0.1,12.62 -0.1,6.47 -0.1,12.94 -0.2,19.34 -0.1,5.79 -0.3,11.5 -0.4,17.13 -0.1,2.81 -0.2,5.62 -0.2,8.44 -0.3,8.43 -0.6,16.79 -0.9,24.8 -0.1,3.66 -0.2,7.15 -0.5,10.65 0,1.53 0,3.06 -0.1,4.6 -0.2,5.03 -0.4,9.88 -0.7,14.66 -0.1,2.38 -0.2,4.69 -0.3,6.99 -0.1,2.21 -0.3,4.43 -0.3,6.65 -0.2,3.31 -0.4,6.56 -0.6,9.71 l -0.1,1.7 c -0.1,3.58 -0.3,6.99 -0.6,10.14 -0.3,6.56 -0.8,12.19 -1,16.63 -0.1,0.93 -0.1,1.78 -0.1,2.63 -0.2,2.47 -0.3,4.44 -0.5,5.88 0,0.85 -0.1,1.45 -0.1,1.97 l -0.1,1.02 271,53.6 0.9,0.17 15.4,3.07 17.1,3.41 v -0.09 c -0.1,-17.98 0.3,-35.37 1,-52.24 8.6,-190.13 65.7,-306.53 100.5,-315.66 1.8,-0.34 3.7,-0.85 5.6,-1.36 h 0.1 c 32.6,-9.12 69.5,-38.95 106,-84.29 47.4,-58.54 94.1,-143.08 130.2,-241.77 52.8,-144.96 82.8,-320.78 57.6,-490.32"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.25315)",
    id: "g238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path240",
    style: {
      fill: "#c6dff7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16004.7,8727.27 c 0,0 6.7,-92.92 6.9,-180.46 165.3,4.66 252.6,155.39 288.4,238.93 l -295.3,-58.47"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.26489)",
    id: "g242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path244",
    style: {
      fill: "#8ab7f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16179,8736.07 c 0,0 85.7,135.54 106.3,251.43 14.7,82.75 -27.4,389.46 -335.6,345.28 0,0 -89.6,-8.82 -173.7,-65.65 -66.9,-45.19 -163.5,-142.77 -55.5,-410.4 l 28.1,-90.41 430.4,-30.25"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.2602)",
    id: "g246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path248",
    style: {
      fill: "#dcecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15860.4,8596.07 c 0,0 388.7,-6.41 389,235.73 0.3,242.14 50.6,404.4 -197.6,418.73 -248.2,14.33 -296.5,-78.02 -316.2,-158.81 -19.8,-80.81 23.7,-487.74 124.8,-495.65"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.26628)",
    id: "g250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path252",
    style: {
      fill: "#8ab7f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15798.5,9211.97 c 0,0 105.9,-282.71 268.5,-324.51 162.5,-41.8 233,1.75 233,1.75 0,0 -124.7,99.05 -150.5,271.95 0,0 -271.1,185.37 -351,50.81"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.22936)",
    id: "g254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path256",
    style: {
      fill: "#8ab7f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,9464.98 c 0,0 -81.5,-65.01 -101.4,-128.22 -19.8,-63.2 -28.7,-193.32 -66.7,-188.89 0,0 -82.2,197.93 10.2,309.89 98,118.73 157.9,7.22 157.9,7.22"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.30936)",
    id: "g258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path260",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15970.5,6978.21 c 24.5,-160.46 63,-326.27 98.7,-474.81 h -1191 c 23.6,265.09 78.1,562.41 90.1,768.31 1,16.95 1.7,33.3 2,48.88 -17.8,107.61 -23.9,201.01 -22,281.2 5.1,216.27 68.6,337.5 117.4,386.3 13.7,10.56 27.6,17.19 83.1,26.74 28.3,4.79 67.6,10.4 123.3,17.7 0,0 0.8,0.09 2.2,0.25 0.5,0 1.1,0.08 1.8,0.16 1.5,0.17 3.2,0.34 5,0.51 2.1,0.25 4.5,0.5 6.6,0.67 1.3,0.08 2.4,0.17 3.4,0.25 2.1,0.09 3.3,0.09 3.2,-0.08 -3.4,-6.12 -5.6,-25.24 -5.9,-49.72 -0.7,-48.46 5.8,-118.13 22.2,-150.59 63,-124.16 238.4,-112.51 315.4,1.01 2.1,3.11 4.1,6.2 6,9.48 45.1,75.12 84,205.61 84,205.61 l 6.5,-0.45 c 14.7,-1.42 84.7,1.86 153.2,-12.64 62.1,-13.16 121.8,-43.87 159.2,-71.12 l -0.9,-1.09 c 10.2,-7.29 17.9,-15.09 22.3,-23.39 23.2,-44.18 46.4,-105.81 69.2,-178.08 65.6,-208.79 127.4,-507.1 174.5,-736.91 -153.6,-84.55 -287.8,-59.42 -329.5,-48.19"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.32352)",
    id: "g262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path264",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,6433.82 h -1631.5 c -6.1,192.29 4,545.21 139.6,760.09 14.3,22.59 30,43.68 47.1,62.79 40,44.8 88.3,79.49 146.4,99.51 50.8,17.45 99.6,39.36 146.1,64.37 146.8,78.88 271.2,188.51 364.9,287.71 62.7,66.19 111.8,127.65 144.9,172.11 20,26.96 34.3,47.61 42,59.39 4.7,7.05 7.2,10.87 7.2,10.87 0,0 186.6,-41.48 290.3,-145.16 12.8,-12.78 27.4,-45.29 43,-92.49 87.4,-262.43 210.4,-979 260,-1279.19"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.23865)",
    id: "g266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path268",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,7744.8 v -870.14 h -731.4 c 51.1,400.19 192.7,1459.02 269,1548.71 94.1,110.79 340.6,71 340.6,71 0,0 -7.4,-20.66 -17,-53.98 -22.5,-78.44 -57,-227.16 -35.6,-343.79 10.3,-56.32 33.6,-114.77 60,-167.57 51.4,-103.01 114.4,-184.23 114.4,-184.23"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.26367)",
    id: "g270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path272",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15748.6,9238.16 c 0,0 79.6,53.14 259,-13.1 179.5,-66.23 199,-342.05 199,-342.05 0,0 71.6,65.15 82.6,123.79 10.8,58.65 -43.9,252.82 -108.7,297.55 -91.2,62.99 -219.4,71.67 -299.7,49.95 -80.4,-21.72 -132.2,-116.14 -132.2,-116.14"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.28175)",
    id: "g274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path276",
    style: {
      fill: "#abcdf4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,7581.52 c 0,0 -285.5,-519.6 -531.1,-582.41 -245.5,-62.8 -62.8,-182.72 119.9,-74.27 182.8,108.52 411.2,656.68 411.2,656.68"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.2859)",
    id: "g278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path280",
    style: {
      fill: "#abcdf4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,7299.47 c 0,0 -149.5,-268.92 -256.2,-375.61 -106.7,-106.7 52.3,-120.7 117.9,-41.14 65.7,79.55 138.3,416.75 138.3,416.75"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.21215)",
    id: "g282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path284",
    style: {
      fill: "#abcdf4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16277.3,8282.46 c 0,0 -31.3,-159.23 -56.4,-287.93 -25.1,-128.69 -20.6,-395.82 29.3,-377.76 49.8,18.15 27.1,665.69 27.1,665.69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.34307)",
    id: "g286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path288",
    style: {
      fill: "#8eb9ed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 16161,6409.73 H 14239.9 V 9070.62 H 16161 Z M 14100.9,9209.57 V 6270.72 H 16300 v 2938.85 h -2199.1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.19713)",
    id: "g290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path292",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16272.5,12310 v -1977.7 -30.1 h 27.5 v 30.1 1957.3 l -27.5,20.4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.3133)",
    id: "g294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path296",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16274.9,10371.8 v -953.49 -27.41 h 25.1 v 27.41 944.79 l -25.1,8.7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path298",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11470.8,8145.1 -7177.15,8.2 14.39,3943.7 H 11470.8 V 8145.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path300",
    style: {
      fill: "#dcecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4279.01,11713.8 c 0,0 417.17,186.6 878.25,43.9 461.07,-142.7 625.74,-274.4 625.74,-274.4 0,0 362.28,252.5 856.29,109.7 494.01,-142.7 472.05,-494 472.05,-494 0,0 193.95,62.2 376.91,-3.6 182.97,-65.9 190.29,-175.7 190.29,-175.7 0,0 300.07,409.9 907.52,322 607.45,-87.8 644.04,-629.4 644.04,-629.4 0,0 142.72,179.3 367.77,119 0,0 65.86,362.2 510.53,340.3 0,0 181.1,340.3 598.3,268.9 417.1,-71.3 439.1,-312.8 439.1,-312.8 0,0 159.1,181.1 356.8,109.7 v -795.9 H 4268.03 c 0,0 0,1383.3 10.98,1372.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path302",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9398.44,10385.4 c 0,0 6.28,5.6 18.54,14.6 58.7,43.2 254.46,165.4 554.14,133.7 362.28,-38.5 483.08,192.1 828.88,203.1 345.8,10.9 428.1,241.5 702.6,230.5 v -625.8 l -2104.16,43.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path304",
    style: {
      fill: "#b8d1f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4272.41,11482.2 -4.38,12 c 0,0 1.54,0.2 4.52,0.5 -0.05,-4.1 -0.09,-8.3 -0.14,-12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path306",
    style: {
      fill: "#bdd5f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9061.73,10441.8 c -284.67,19 -570.27,46.7 -841.6,86.4 -531.7,77.7 -1215.71,102.1 -1864.82,102.1 -1000.47,0 -1917.92,-58 -2066.36,-67.8 l -6.28,891.5 -10.26,28.2 c 0.05,4.2 0.09,8.4 0.14,12.5 16.68,1.6 78.44,6.9 167.08,6.9 208.99,0 567.58,-29.3 838.39,-205 406.18,-263.4 911.17,-65.8 1295.4,-263.4 384.23,-197.6 790.42,-33 1083.17,-186.7 279.72,-146.8 492.65,-293.7 804.74,-293.7 14.53,0 29.24,0.3 44.22,1 70.44,3 135.46,5.1 194.34,5.1 199.81,0 329.13,-24.1 361.84,-117.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path308",
    style: {
      fill: "#d2e3fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4268.03,10561.1 c 0,0 2524.95,175.7 3952.1,-32.9 1427.14,-208.6 3249.47,-87.8 3249.47,-87.8 V 8145.1 H 4308.04 c 0,0 -56.47,2432.5 -40.01,2416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path310",
    style: {
      fill: "#b8d1f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 11491.6,8145.1 H 4308.04 v 0 0 h 7161.56 1.2 v 1122.7 c 13.7,-1.4 20.8,-2.1 20.8,-2.1 V 8145.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path312",
    style: {
      fill: "#adcbf7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11470.8,8145.1 h -1.2 V 9268 c 0.4,-0.1 0.8,-0.1 1.2,-0.2 V 8145.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path314",
    style: {
      fill: "#b8d1f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 11469.6,8145.1 H 4308.04 v 0 c -0.07,3.2 -39.56,2021 -18.4,2021 0.11,0 0.23,-0.1 0.35,-0.2 0,0 2788.42,0 4325.34,-384.2 C 10037.4,9426.1 11290.4,9286.8 11469.6,9268 V 8145.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path316",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4279.01,9726.8 c 0,0 1954.09,98.8 2305.39,-285.5 351.29,-384.2 -351.3,-614.7 351.29,-724.5 702.6,-109.8 2305.39,-22 2305.39,-570.9 H 4308.04 c 0,0 -40.01,1591.8 -29.03,1580.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path318",
    style: {
      fill: "#e6f1ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 11494.7,8153.1 H 4292.29 v 3941.5 H 11494.7 Z M 3951.98,12434.9 V 7812.7 H 11835 v 4622.2 H 3951.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path320",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10861.6,14880.2 v -2453.9 h 32.9 v 2474 l -32.9,-20.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path322",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4900.81,12933.6 v -507.3 h -32.94 v 498.5 l 32.94,8.8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.43569)",
    id: "g324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path326",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,9249.41 v -525.39 -289.5 -23.86 -147.04 -176.25 h -18.2 v 176.25 147.04 23.86 289.5 525.93 l 18.2,-0.54"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.6065)",
    id: "g328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path330",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16283.8,8253.92 v -457.51 -258.71 -21.32 -131.41 -157.51 h 16.2 v 157.51 131.41 21.32 258.71 456 l -16.2,1.51"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.66015)",
    id: "g332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path334",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 16300,5171.29 H 13722.4 V 7294.14 H 16300 V 5171.29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.64483)",
    id: "g336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path338",
    style: {
      fill: "#a1c3e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,7212.9 v -993.29 c -0.7,-337.62 -2.4,-755.47 -2.7,-821.13 h -2272 V 7212.9 H 16300"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.64456)",
    id: "g340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path342",
    style: {
      fill: "#83b7e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,6330.52 v -931.16 h -2272.4 v 931.16 H 16300"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.55781)",
    id: "g344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path346",
    style: {
      fill: "#e6f1ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16169.6,7286.29 c 0,35.99 29.2,65.17 65.2,65.17 36,0 65.2,-29.18 65.2,-65.17 0,-35.98 -29.2,-65.16 -65.2,-65.16 -36,0 -65.2,29.18 -65.2,65.16"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.64488)",
    id: "g348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path350",
    style: {
      fill: "#7faadd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16299.5,6219.42 c -0.7,-337.6 -2.4,-755.45 -2.7,-821.1 h -1823 c 24.6,301.29 942.6,647.58 974,703.51 31.8,56.44 -797.9,95.22 -819.2,169.27 -4.8,16.83 27.6,36.61 83.4,58.19 189.6,73.58 649.1,168.8 834.6,245.08 240.1,98.75 752,88.17 752,88.17 0.4,0 0.7,-17.34 0.9,-48.08 0.5,-72.84 0.4,-223.59 0,-395.04"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.52693)",
    id: "g352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path354",
    style: {
      fill: "#c4daef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,7331 -718.8,7.34 c 0,0 32.3,59.33 108.8,59.33 4.1,0 8.5,-0.18 13.1,-0.57 0,0 60.7,53.63 142.7,53.63 35.5,0 74.9,-10.07 115.1,-38.94 0,0 37.9,6.33 88.9,6.33 47.6,0 106.7,-5.51 157.3,-26.81 69.8,-29.43 92.9,-60.31 92.9,-60.31"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.62135)",
    id: "g356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path358",
    style: {
      fill: "#c4daef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,7072.24 -509.8,5.21 c 0,0 22.9,42.08 77.1,42.08 3,0 6.1,-0.13 9.3,-0.41 0,0 43.1,38.04 101.2,38.04 25.2,0 53.2,-7.14 81.7,-27.62 0,0 26.9,4.49 63.1,4.49 33.7,0 75.6,-3.9 111.5,-19.02 49.5,-20.88 65.9,-42.77 65.9,-42.77"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.51947)",
    id: "g360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path362",
    style: {
      fill: "#c4daef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,7143.27 -960.5,8.15 c 0,0 43.1,65.84 145.3,65.84 5.6,0 11.5,-0.2 17.6,-0.63 0,0 81.1,59.52 190.5,59.52 47.5,0 100.2,-11.17 154,-43.22 0,0 50.5,7.03 118.8,7.03 63.6,0 142.6,-6.11 210.1,-29.76 93.3,-32.66 124.2,-66.93 124.2,-66.93"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.00053)",
    id: "g364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path366",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16030.4,10736.6 c 30.6,-84.5 60.2,-166.7 60.2,-166.7 l -618.5,20.1 -380.1,158.4 -27.8,11.5 c 13.8,14.1 26.3,27.1 37.5,39.2 100.4,106.3 112.4,136.1 112.4,136.1 -6.7,38.6 -11.8,74.7 -15.8,109.6 -1.7,1.2 -3.7,2.2 -5.5,3.7 0,0 4,26.4 -46.4,201.4 -8,28 -17.6,59.9 -28.6,96.2 -8.8,28.4 -12,53.9 -12,76.8 0,63.9 26.1,108.3 37.3,139.6 4.6,12.8 11.1,26.6 0.5,22.3 -47.4,-33.8 -258.1,154.5 -283.2,247 12.8,13 25.6,25.8 38.3,38.4 l -1,0.7 c 0,0 177.8,193.8 257.7,218.1 42.7,13.1 126.9,15.8 187.3,15.8 40.2,0 70,-1.2 70,-1.2 5.8,0.2 11.8,0.7 17.6,1 38.3,2.5 69.4,32.1 73.6,70.4 3,27.1 5.8,59.5 8.6,97.8 0.5,8 1,16.6 1.5,25.1 28.1,34.3 285.1,-59.2 285.1,-59.2 0,0 2.7,-2.5 4.5,-8 0,-7 0.2,-14 0.5,-21.3 0.2,-18.1 1.3,-36.9 3.3,-55.4 0.2,-1.5 0.2,-2.8 0.5,-4.3 3,-26.8 28,-42.6 54.6,-47.9 8.5,-1.7 17,-3.5 25.8,-5.2 v 0.5 c 0,0 275.3,-28.9 326.7,-89.3 38.6,-45.1 63.2,-108.3 78.5,-160.2 2,-7 4,-14 5.7,-20.6 0.8,-114.8 -78.7,-282 -210.1,-456 -2.7,-3.8 -1.7,-9.1 -2,-13.6 -2.2,-11.5 -5.7,-24.5 -10.8,-39.8 -42.1,-132.7 -107.5,-328.5 -113.8,-329.5 -1.5,-41.1 -0.5,-68.7 3.1,-77 8,-18 37.1,-97 64.8,-174.5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path368",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15575.4,8950.1 c -78.8,-253.4 -38.4,-383.3 -38.4,-383.3 112.7,-509.2 26.3,-1428.8 26.3,-1428.8 h -176.8 c -267,702.2 -275,1142.8 -290.2,1308.2 -15.2,165.4 -412.4,1240.6 -413.5,1471 -1.2,240.2 238.1,625.6 238.1,625.6 0,0 344,-132.7 556.2,-263.8 70.9,-43.7 125.1,-86.5 143.6,-122.8 49.2,-96.5 85.7,-785.4 -45.3,-1206.1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.01757)",
    id: "g370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path372",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,7040.3 h -195.1 c 0,0 -760.8,1099.87 -786.9,1379.46 -32.8,349.75 -277.2,1730.04 -277.2,1730.04 l 780.5,243 c 0,0 68.2,-175.4 125.4,-352.3 24.9,-77.11 47.7,-154.52 61.8,-217.79 31.3,-139.55 -56.7,-667.18 -116.7,-1042.19 -29.7,-184.75 -52.6,-332.55 -51,-378.65 4.5,-139.94 261,-158.12 459.2,-1361.57"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16289.8,9995.3 c 0,0 -237.6,-7.8 -474.5,-72.7 -157.8,-43.2 -315.3,-111.7 -402.1,-219.9 0,0 -225.8,244.2 -495,304.9 h -0.1 c -73.5,16.6 -150.2,19.5 -226.5,0 0,0 6.7,249.5 326.2,686 21.2,29 43.8,58.8 67.8,89.4 0,0 306.8,-176.9 809.9,-67.2 45.9,10 93.6,22.4 142.7,37.6 0,0 115.3,-278.2 152.4,-389.9 25.9,-77.8 99.2,-368.2 99.2,-368.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15386.5,7138 c 0,0 -10,-115.3 -24.8,-139 -14.9,-23.7 -77.2,-103.8 -148.3,-130.5 -71.2,-26.7 -274.9,-12.9 -290.7,-86.9 h 717.8 c 0,0 9.8,110.9 -17.8,183.9 -27.7,73 -59.4,172.5 -59.4,172.5 h -176.8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.03293)",
    id: "g378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path380",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16057.7,6935.63 c 0,0 77.6,-106.2 96.8,-148.31 19.2,-42.12 145.5,-220.35 130.2,-221.9 -15.3,-1.45 -352.2,0 -352.2,0 0,0 -34.5,84.13 -30.7,141.54 3.9,57.41 -45.9,166.42 -36.3,228.67 9.5,62.25 192.2,0 192.2,0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path382",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15109.8,10804.8 c -3.5,-18 -6.7,-35.1 -9.7,-50.7 l -27.9,11.6 c 13.8,14 26.4,27.1 37.6,39.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path384",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15812.5,12215.9 c 0,-1 -0.5,-2.3 -0.8,-3.5 -6.5,-23.6 -103.3,-27.8 -162.5,-15.3 -48.7,10.5 -116.2,46.4 -128.4,82.3 -3.1,7.5 -3.3,15 -0.3,22.3 0.5,1 1,2 1.8,2.7 28.1,34.4 285.2,-59.1 285.2,-59.1 0,0 2.7,-2.6 4.5,-8.1 1.8,-4.7 2.5,-11.8 0.5,-21.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path386",
    style: {
      fill: "#afcdfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15573.8,11354.7 c 0,0 78.4,-81.5 203.8,-78.4 125.5,3.1 203.9,122.3 191.3,159.9 -12.5,37.7 -141.1,-43.9 -219.5,-31.3 -78.4,12.5 -210.1,15.7 -175.6,-50.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path388",
    style: {
      fill: "#afcdfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15116.5,11412.2 c 0,0 31.8,-79.8 119,-109.1 87.1,-29.4 173.2,38.5 174.7,69.4 1.6,30.9 -108.9,3.3 -159.4,32.3 -50.5,29.1 -140.3,64.6 -134.3,7.4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.0051)",
    id: "g390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path392",
    style: {
      fill: "#afcdfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16209.2,9612.34 c 25.6,-537.56 -212,-1184.06 -449.3,-1686.2 l -0.2,-0.49 c -77.4,-163.47 -154.8,-311.71 -222.9,-435.98 -131,-238.18 -228.4,-387.92 -228.4,-387.92 l -253.5,719.83 c -62.4,74.91 -143.6,605.21 -143.6,605.21 -74.8,112.32 -216.4,911.05 -216.4,911.05 -108.1,112.32 -86.1,336.88 -86.1,336.88 -46.9,68.65 -15.7,168.54 -15.7,168.54 -18.7,84.07 24,113.52 24,113.52 529.1,44.92 1400.3,565.02 1400.3,565.02 282.6,-313.4 191.8,-909.46 191.8,-909.46"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path394",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15846.6,7993.2 c 0,0 -2.2,-9.8 -6.3,-26.6 l -0.2,-0.5 c -77.8,-164.3 -155.5,-313.3 -224,-438.2 -0.5,4.2 -1,9 -1.5,13.8 -37.7,370 -138,928.1 -77.5,1025.2 60.2,96.8 309.5,-573.7 309.5,-573.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path396",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16170.6,10506 c 0,0 -710.7,-526.8 -995,-685.7 -284.3,-158.9 125.4,-158.9 384.6,83.6 259.2,242.5 610.4,602.1 610.4,602.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path398",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16187.4,10405.6 c 0,0 -378.4,-719.1 -804.9,-957.4 -426.4,-238.3 -476.6,-332.4 -338.6,-313.6 137.9,18.8 664.7,363.8 783.9,551.9 119.2,188.1 359.6,719.1 359.6,719.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path400",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16170.6,10004.3 c 0,0 -108.7,-694.1 -225.7,-936.6 -117.1,-242.5 -33.5,-501.7 16.7,-485 0,0 79.4,56.5 79.4,138 0,81.5 190.3,829.9 129.6,1283.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path402",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14987.4,8469.8 c 0,0 209.1,-175.6 230,-83.6 20.9,92 -200.7,41.8 -230,83.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path404",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14770,9385.5 c 0,0 104.5,-18.8 173.5,12.5 69,31.4 91,109.8 43.9,94.1 -47,-15.7 -111.8,-103.5 -217.4,-106.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path406",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14683.3,9724.1 c 0,0 116,-84.6 166.2,-65.8 50.1,18.8 -166.2,65.8 -166.2,65.8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.04812)",
    id: "g408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path410",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,6190.25 h -2237.8 v 275.16 H 16300 v -275.16"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.06736)",
    id: "g412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path414",
    style: {
      fill: "#bdd8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 16300,3557.95 H 13514.9 V 6080.54 H 16300 V 3557.95"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.00944)",
    id: "g416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path418",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,5652.33 h -1074.5 v 326.12 H 16300 v -326.12"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.01547)",
    id: "g420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path422",
    style: {
      fill: "#9ebfef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15065.9,5559.29 h 1206.4 v 443.24 H 15065.9 Z M 16300,5531.61 H 15038.2 V 6030.2 H 16300 v -498.59"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.16163)",
    id: "g424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path426",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16263.2,6456.38 c 0,2.5 36.8,78.6 25.1,84.54 -11.7,5.85 -32.7,4.91 -35.1,-8.44 -2.4,-13.25 10,-76.1 10,-76.1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.23221)",
    id: "g428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path430",
    style: {
      fill: "#233862",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15849.7,6978.49 c 0,0 203.4,244.6 311.2,88.05 0,0 80.3,-33.35 109.5,-170.09 29.6,-139.67 -63.2,-245.74 -111.2,-219.53 -30.8,16.8 -54.1,-37.01 -54.1,-37.01 l -255.4,338.58"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.19428)",
    id: "g432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path434",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16092.7,5857.44 c -166.9,61.54 -327.8,347.24 -327.8,347.24 l 52.7,36.84 c 43.9,-64.14 241.2,-187.31 241.2,-187.31 4.5,54.01 11,103.08 19.1,147.54 54.7,301.86 180.1,391.28 213.6,410.29 5.5,3.1 8.5,4.27 8.5,4.27 0,0 -0.1,-2.18 -0.3,-6.36 -0.5,-9.13 -1.5,-27.47 -3.3,-52.5 -13.1,-186.98 -64.2,-751.42 -203.7,-700.01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.23769)",
    id: "g436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path438",
    style: {
      fill: "#233862",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16067.3,7060.02 c 0,0 27.2,109 187.3,74.9 0,0 -76.6,9.7 -97.6,-19.88 0,0 60.7,27.88 98.7,4.61 38.1,-23.27 44.3,-101.64 38.6,-125.47 -5.6,-23.84 -47.6,-94.78 -75.4,-94.78 -27.9,0 -60.8,24.4 -60.8,24.4 l -90.8,136.22"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.24154)",
    id: "g440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path442",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16256.2,5337.89 c -79.4,177.92 -117.3,228.26 -118.6,284.24 -1,44.3 20.8,92.06 63.2,209.18 10,27.54 16.8,55.98 21.1,84.65 33.5,225.77 -97.1,469.82 -178.2,486.49 -22.5,5.96 -60.9,87.47 -60.4,218.92 l -10.2,-2.01 -170.8,-33.83 c 0,0 3.9,-53.8 4,-104.47 0.1,-42.2 -2.5,-82.23 -12,-87.23 -12.3,-1.12 -19.5,-1.85 -19.5,-1.85 0,0 -142.5,-197.9 -154.5,-381.86 -12,-184.05 114,-264.03 -1,-631.8 -117.4,-375.58 680.7,-138.7 636.9,-40.43"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.21664)",
    id: "g444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path446",
    style: {
      fill: "#e8945b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16125.7,6720.29 c 0,0 3.9,-54.91 4,-106.61 97.6,2.8 149.2,91.81 170.3,141.13 l -174.3,-34.52"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.22337)",
    id: "g448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path450",
    style: {
      fill: "#233862",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16228.2,6736.53 c 0,0 50.9,80.36 63.1,149.1 8.7,49.04 -16.2,230.84 -199,204.68 0,0 -53.1,-5.23 -102.9,-38.91 -39.7,-26.81 -97,-84.68 -33,-243.34 l 16.7,-53.63 255.1,-17.9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.22069)",
    id: "g452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path454",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16039.7,6649.21 c 0,0 230.2,-3.77 230.3,139.59 0.2,143.28 30,239.37 -117,247.81 -146.8,8.52 -175.4,-46.12 -187.2,-93.96 -11.6,-47.84 14.1,-288.69 73.9,-293.44"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.22418)",
    id: "g456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path458",
    style: {
      fill: "#233862",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16002.5,7020.06 c 0,0 62.8,-167.71 159.2,-192.46 96.5,-24.75 138.3,1.06 138.3,1.06 0,0 -74,58.74 -89.4,161.25 0,0 -160.7,109.96 -208.1,30.15"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.20301)",
    id: "g460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path462",
    style: {
      fill: "#233862",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,7129.72 c 0,0 -47.8,-38.07 -59.4,-75.06 -11.7,-37.07 -16.9,-113.3 -39.1,-110.72 0,0 -48.1,115.96 6,181.63 57.3,69.49 92.5,4.15 92.5,4.15"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.22298)",
    id: "g464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path466",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16217,3685.77 c -57.7,-229.85 -144.7,-406.06 -144.7,-406.06 l -86.3,-9.41 c 0,0 47.7,191.34 45.6,430.1 -1.6,166.89 -22.2,364.11 -88.2,552.51 -226.6,647.19 262.9,604.59 267.3,396.82 3.9,-186.92 7.4,-326.91 7.4,-326.91 81.9,-176.46 52.1,-425.52 -1.1,-637.05"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.26061)",
    id: "g468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path470",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,5071.02 -66.9,-20.07 c 0,0 -220.7,366.18 -240.7,461.37 -6.5,31.01 -22.6,93.13 -41.3,162.62 -38.8,144.05 -88.7,320.24 -88.7,320.24 l -16.5,71.31 -56.2,243.29 c 0,0 107.6,-11.02 170.5,-37.36 20.8,-8.64 36.7,-19.03 42.2,-31.17 46.3,-101.7 92.4,-358.08 124.8,-541.09 18.1,-101.93 31.9,-181.1 39.1,-197.84 20,-46.8 81.3,-304.22 133.7,-431.3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.2425)",
    id: "g472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path474",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16284.1,3663.97 c -24.1,-257.38 -130.3,-423.82 -130.3,-423.82 l -35.6,-25.91 c 0,0 -33.7,181.32 -57.6,397.1 -22.7,205.07 -53.9,422.05 -89.1,488.29 -139.9,262.69 -182,1254.32 -182,1254.32 l 425.3,21.09 c 42.8,-71.88 61.4,-189.86 65.8,-323.95 11.2,-338.43 -68.3,-779.71 -80.2,-843.53 v -0.17 c -1,-4.9 0.4,-9.82 2.8,-14.24 84.6,-167.49 96.8,-359.11 80.9,-529.18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.21485)",
    id: "g476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path478",
    style: {
      fill: "#233862",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16132.3,7054.55 c 0,0 45.1,-176.89 167.7,-233.6 0,0 -122.6,108.73 -133,225.54 -10.4,116.8 -34.7,8.06 -34.7,8.06"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.25317)",
    id: "g480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path482",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16158.2,5161.14 c 0.7,-14.2 110.2,-1248.51 107.6,-1256.65 -9,-28.24 -846.7,-157.04 -870.5,16.12 -26.2,190.48 47.9,1803.66 52.2,1985.52 -10.7,64.48 -14.3,120.42 -13.1,168.54 3,129.51 41,202.12 70.3,231.33 8.3,6.38 16.5,10.29 49.8,16.04 16.9,2.87 40.5,6.22 73.8,10.61 l 13.3,1.04 c -6.2,-11.02 -59.8,-107.49 -56.9,-140.13 6.7,-75.24 158.6,-68.54 244.5,-16.11 67.6,41.17 101.8,163.42 101.8,163.42 0,0 103.6,-11.33 154.3,-48.2 l -0.5,-0.64 c 6.1,-4.39 10.7,-9.01 13.3,-13.96 54,-103.02 164,-453.97 201.9,-639.34 -20.1,-130.95 -150.3,-188.08 -175.2,-181.38 9.3,-155.12 28.5,-199.01 33.4,-296.21"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.15938)",
    id: "g484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path486",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16293.7,6429.38 c 0,7.42 6.3,115.67 -13,138.44 -19.3,22.68 -58.6,55.03 -70.9,53.99 -12.4,-0.95 -60.8,-65.2 -46.3,-114.46 14.6,-49.33 75.9,-115.92 75.9,-115.92 l 54.3,37.95"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.16582)",
    id: "g488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path490",
    style: {
      fill: "#f1a34f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16291.7,6515.49 -139.8,-3.09 c -4.7,-0.17 -8.5,3.52 -8.6,8.15 l -6.1,266.68 c -0.1,4.63 3.6,8.49 8.2,8.57 l 139.8,3.18 c 4.8,0.08 8.5,-3.52 8.7,-8.24 l 6,-266.59 c 0.1,-4.63 -3.6,-8.49 -8.2,-8.66"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.16369)",
    id: "g492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path494",
    style: {
      fill: "#d86713",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16285.2,6526.67 -127.1,-2.92 c -8.2,-0.17 -15.1,6.36 -15.3,14.61 l -5.7,254.1 c -0.2,8.25 6.3,15.12 14.6,15.3 l 127.1,2.92 c 8.2,0.17 15,-6.36 15.2,-14.61 l 5.7,-254.11 c 0.3,-8.25 -6.2,-15.12 -14.5,-15.29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.19946)",
    id: "g496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path498",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16217.3,5813.37 c -5.1,0.25 -49.3,-3.51 -93.9,-7.01 -46.1,-3.58 -92.8,-7.08 -97.7,-5.67 -11.3,3.34 -22.1,13.26 -32.3,27.68 -49.9,70.87 -83.5,248.11 -83.5,248.11 11.8,72.04 93.3,99.63 108.8,165.66 74.4,315.81 193.3,352.41 193.3,352.41 0,0 88,-785.6 5.3,-781.18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.15793)",
    id: "g500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path502",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16218.5,6621.8 c 0,0 46.7,71.94 58.1,67.97 16.3,-5.7 -42.4,-96.99 -42.4,-96.99 0,0 43.5,68.15 50.3,63.05 15.5,-11.66 -37.9,-121.51 -37.9,-121.51 l -32.1,37.65 4,49.83"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.15259)",
    id: "g504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path506",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16258.4,6585.44 c 2.3,8.84 31.8,181.24 36.7,164.84 4.9,-16.39 1.9,-104.98 1.9,-104.98 l -38.6,-59.86"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.20611)",
    id: "g508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path510",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16297,3325.57 -73.9,55.13 c 0,0 -9.1,-43.19 -20.9,-56.79 -19.4,-22.47 -57.7,-47.68 -72.2,-58.62 -22.9,-17.41 -100.1,-49.42 -100.1,-50.08 0,-28.19 150.4,-29.35 186.6,-33.49 36.3,-4.23 69.5,-3.57 77.9,24.37 5.6,18.82 -3.1,56.55 -3.4,87.97 -0.2,15.17 6,31.51 6,31.51"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.20624)",
    id: "g512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path514",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16191.1,3156.59 c -58.1,2.9 -41.7,1.74 -122.3,-5.14 -80.5,-6.88 -110.3,17.74 -115,29.01 -4.2,9.95 33.6,21.31 74.4,34.41 l 1.5,-0.75 c 0,0 53.4,-24.12 119.3,-12.68 53.8,9.28 107.4,35.89 144.4,42.61 3.3,-12.1 6.6,-24.37 6.5,-37.14 -0.1,-36.15 -5.2,-55.55 -108.8,-50.32"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.23614)",
    id: "g516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path518",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,3389.68 -121.6,-14.24 c 0,0 6.5,-96.75 -0.3,-120.54 -15.4,-53.79 -48.4,-71.51 -74.2,-82.43 -25.8,-10.84 -98.4,-34.71 -98.4,-35.35 0,-27.51 146.7,-28.64 182.1,-32.69 35.5,-4.12 67.7,-3.47 75.9,23.79 5.5,18.36 -2.9,55.17 -3.3,85.83 -0.2,14.81 39.8,175.63 39.8,175.63"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.23391)",
    id: "g520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path522",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16205,3084.09 c -47.1,3.4 -52.2,3.4 -130.9,-3.32 -78.8,-6.73 -107.8,17.34 -112.5,28.36 -4.1,9.72 32.8,20.83 72.7,33.64 l 1.5,-0.74 c 0,0 52.3,-23.58 116.7,-12.4 52.5,9.08 104.9,35.1 141.1,41.66 3.2,-11.83 6.4,-23.83 6.4,-36.31 -0.1,-35.33 -18.2,-56.32 -95,-50.89"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.24269)",
    id: "g524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path526",
    style: {
      fill: "#0f2949",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16260.7,5503.37 c 1.3,0 -104.3,363.08 -117.9,338.7 -13.5,-24.38 157.2,-717.96 157.2,-717.96 l -39.3,379.26"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.18981)",
    id: "g528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path530",
    style: {
      fill: "#0f2949",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16255.5,5854.13 -1.3,-0.67 c -46.5,-3.62 -93.6,-7.15 -98.5,-5.72 -11.4,3.36 -22.3,13.37 -32.6,27.9 14.8,19.34 71.9,39.34 92,52.79 25.5,16.98 67.9,201.63 76.4,167.67 8.5,-33.95 -36,-241.97 -36,-241.97"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.20498)",
    id: "g532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path534",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,6813.75 c 0,0 -4,-17.1 -46.6,-14.44 0,0 -35.7,2.16 -34.6,20.99 0,0 34.6,13.36 81.2,-6.55"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.27053)",
    id: "g536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path538",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16166.8,5039.4 c 0,0 80.1,-53.2 92.3,-75.63 12.3,-22.44 40.9,-105.08 40.9,-105.08 0,0 -20.5,-3.07 -40.9,32.66 -20.3,35.66 -87.6,32.67 -110.1,52.03 -22.4,19.36 -48.5,76.11 -48.5,76.11 l 66.3,19.91"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.26242)",
    id: "g540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path542",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16212.7,5034.07 c 0,0 13.4,-63.05 29.8,-81.51 16.5,-18.53 39,-49.27 48.2,-41.11 9.3,8.24 -10.2,77 -10.2,77 l -67.8,45.62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.27212)",
    id: "g544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path546",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16227.7,4950.41 c 2,-3.06 72.3,-77.74 72.3,-77.74 0,0 -25.5,-11.56 -32.6,0 -7.2,11.55 -39.7,77.74 -39.7,77.74"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path548",
    style: {
      fill: "#aa3e39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10079.1,7954.7 c 0,0 352.9,-356.6 370.4,-500.8 17.4,-144.1 -176.9,-369.1 -176.9,-369.1 l -193.5,869.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path550",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9895.78,4012.1 c 0,0 -13.97,-208.6 -53.28,-211.5 -5.23,-0.3 -198.75,0.6 -198.75,0.6 l -262.5,2.5 c 0,0 16.77,64.2 89.23,76.6 72.47,12.5 193.82,63.1 237.91,158.8 46.38,100.6 187.39,-27 187.39,-27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path552",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10447.7,4010.9 c 0,0 -13,-203.1 -52.3,-206 -5.2,-0.3 -199.4,0.1 -199.4,0.1 l -250.37,-4.4 c 0,0 4.35,66.1 76.77,78.5 72.5,12.5 193.9,63.1 237.9,158.8 46.4,100.6 187.4,-27 187.4,-27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path554",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9626.07,6196.1 c 0,0 63.92,-414.6 304.1,-1151 C 10170.4,4308.7 10202.6,3990 10202.6,3990 l 259.4,6.7 c 0,0 4,804.2 -106.7,1174.5 -110.6,370.3 -21.1,1334 -21.1,1334 l -708.13,-309.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path556",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9500.48,6484.3 c 0,0 -10.53,-624.6 95.88,-1391.8 106.41,-767.2 69.07,-1092.7 69.07,-1092.7 l 258.83,-9.2 c 0,0 156.34,766.9 112.84,1150.9 -43.52,384 214.7,1316.9 214.7,1316.9 l -751.32,25.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path558",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10004.8,7945 -138.15,-90.1 -199.24,37.6 c 2.79,16.1 16.1,82.7 28.21,143.1 0.73,3.6 1.46,7.1 2.14,10.6 10.38,51.4 19.34,95.5 19.34,95.5 l 186.34,81.7 69.48,30.5 c -0.19,-1.1 -5.51,-57 -6.25,-65.2 -13.34,-145 38.13,-243.7 38.13,-243.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path560",
    style: {
      fill: "#b64c41",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10351.1,6405.4 c -40.4,-182.6 -706.62,-202.8 -877.98,-36.6 -19.5,18.9 -20.27,106.8 -12.65,225.3 14.92,231.6 61.95,579.8 64.13,757.7 1.07,86 13.07,173.9 28.97,253.6 33.84,170.1 85.17,303.5 85.17,303.5 0,0 325.62,104.5 386.46,86.4 293.1,-86.8 366.4,-1407.4 325.9,-1589.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path562",
    style: {
      fill: "#aa3e39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9460.47,6594.1 c 14.92,231.6 61.95,579.8 64.13,757.7 1.07,86 13.07,173.9 28.97,253.6 l 195.82,34.2 c 0,0 189.68,-782.1 -288.92,-1045.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path564",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9567.17,6916.7 c 0,0 13.27,-32 -14.79,-53.3 -28.07,-21.4 -46.32,-56 -39.95,-81.4 6.36,-25.3 67.73,-66.8 89.05,-60.2 21.32,6.6 64.76,39.9 60.12,53.3 -4.64,13.4 29.42,117.3 -22.43,157.4 -51.86,40.2 -72,-15.8 -72,-15.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path566",
    style: {
      fill: "#b64c41",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9788.31,7955.4 c 0,0 -190.98,-35.3 -343.58,-259.1 -152.59,-223.9 -253.03,-390.3 -225.18,-471.2 27.84,-80.8 282.65,-361.6 326.68,-361.7 44.03,-0.1 115.16,31.8 119.31,103.9 0,0 -179.23,269.9 -143.72,310.2 15.17,17.2 233.88,193.9 264.87,113.8 51.28,-132.6 1.62,564.1 1.62,564.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path568",
    style: {
      fill: "#fca56b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9952.7,8186.2 c -41.03,-69.2 -193.5,-128.7 -257.08,-150.6 0.73,3.6 1.46,7.1 2.14,10.6 10.38,51.4 19.34,95.5 19.34,95.5 l 186.34,81.7 c 41.15,0.5 66.18,-8.7 49.26,-37.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path570",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9646.95,8153.2 c 0,0 299.67,-94.2 355.45,93.3 55.8,187.5 132,301.7 -56.92,369.7 -188.98,68.1 -247.61,7.7 -281.46,-50.4 -33.84,-58.1 -93.58,-383.3 -17.07,-412.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path572",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9675.84,8583.9 c 0,0 18.65,-218.4 63.83,-209.1 45.17,9.4 86.15,16.4 79.39,-49.4 -6.76,-65.8 -69.54,-141.7 69.6,-153.7 139.14,-11.9 339.94,346.6 301.94,414.6 -109.9,196.3 -673.67,237.1 -514.76,-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path574",
    style: {
      fill: "#aa3e39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9718.67,7991.3 c 3.87,1.6 240.18,70.8 265.81,62.2 25.62,-8.5 40.72,-58.1 40.72,-58.1 l -386.46,-86.5 c 0,0 30.54,61.7 79.93,82.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path576",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5951.32,4089.5 -82.85,26.8 c 0,0 -17.19,224.9 19.66,494.3 23.34,170.8 66.15,355.7 143.67,504.2 35.08,67.2 77.27,126.9 127.99,174.6 0,0 63.57,147.5 147.75,344.8 93.62,219.4 679.42,283.7 345.16,-175.8 -68.58,-94.3 -142.23,-260.3 -230.5,-361.1 -150.82,-172.3 -257.25,-373.5 -330.33,-550.5 -104.44,-253.3 -140.55,-457.3 -140.55,-457.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path578",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5762.71,4076.9 c -25.11,-40.7 29.12,-80.6 96.2,-118.1 67.08,-37.6 39.3,-41.4 125.07,-105.2 85.79,-63.9 136.36,-56.9 149.51,-47.5 11.69,8.3 -23.36,47.7 -60.15,90.9 -4.64,5.4 -9.24,10.9 -13.85,16.3 -41.09,49.3 -47.18,111 -66.46,175.1 -18.26,60.7 10.69,211.5 10.69,211.5 l -114.51,90.9 c 0,0 -23.26,-137.1 -36.06,-194.2 -7.52,-33.6 -34.99,-61.7 -57.26,-82.5 -12.07,-11.2 -24.35,-22.9 -33.18,-37.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path580",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5858.91,3958.8 c 67.08,-37.6 39.3,-41.4 125.07,-105.2 85.79,-63.9 136.36,-56.9 149.51,-47.5 11.69,8.3 -23.36,47.7 -60.15,90.9 l -1.12,-0.5 c 0,0 -77.45,10.4 -143.62,69.2 -53.94,47.9 -95.73,115.1 -132.71,148.4 -12.07,-11.2 -24.35,-22.9 -33.18,-37.2 -25.11,-40.7 29.12,-80.6 96.2,-118.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path582",
    style: {
      fill: "#b64c41",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6524.89,8401.8 c 0,0 -202.07,24.5 -303.65,-163.5 -101.59,-188 -93.38,-460.4 -191.87,-588.9 -98.49,-128.5 16.41,-250.3 16.41,-250.3 l 767.39,-25.9 c 0,0 53.35,143.6 0,316 -53.35,172.3 207.24,686.5 -288.28,712.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path584",
    style: {
      fill: "#e8945b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7156.91,6118.3 c 1.53,-30.9 10.23,-96.3 -9.74,-96.3 -16.27,0 -48.27,82.9 -69.21,100.5 -30.38,25.6 -55.13,79.2 -59.08,92.1 -8.13,26.8 -15.77,32.4 -15.77,32.4 h 0.04 -0.09 c 0,0 -242.64,443.6 -261.6,557.2 -6.25,36.9 -22.11,111.1 -40.79,194.2 -20.27,90.3 -43.79,191.2 -61.54,266.8 77.46,15.1 163.14,20.4 233,21.7 14.23,-91.9 26.96,-185.8 37.94,-267.4 16.3,-121.4 28.69,-215.6 36.33,-235.8 21.1,-55.4 79.25,-354 134.07,-509 6.29,-15.2 13.71,-46.6 29.53,-64.3 19.07,-21.3 44.83,-49.8 46.91,-92.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path586",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6734.78,6557.6 c -134.03,428.4 135.76,422.8 121.8,637.2 -13.96,214.4 -179.94,444.9 -179.94,444.9 0,0 -5.95,0.6 -16.33,1.6 -5.68,0.5 -10.58,4.2 -12.54,9.5 -6.19,17 -8,54.1 -7.9,92.7 0.14,59 4.67,121.7 4.67,121.7 l -199.07,39.4 -11.84,2.3 c 0.36,-100.1 -18.59,-175.4 -39.11,-217.4 -9.75,-20 -28.8,-33.7 -50.84,-36.8 -42.77,-6 -118.01,-18.8 -168.73,-40 -24.64,-10.3 -43.43,-22.5 -50,-36.9 -54.66,-120.2 -109.24,-423.6 -147.6,-640 -21.37,-120.6 -37.68,-214.2 -46.19,-234.1 -23.74,-55.3 -96.25,-359.8 -158.21,-510.1 l 79.13,-23.7 c 0,0 261.01,433 284.74,545.7 7.74,36.7 26.72,110.1 48.87,192.4 3.34,12.4 6.77,25.1 10.23,37.8 39.11,-106 59.08,-155.1 57.99,-200.9 -1.55,-65.3 -45.76,-123.9 -138.18,-331.1 -51.06,-114.6 755.89,-291.8 619.05,145.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path588",
    style: {
      fill: "#e8945b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6644.54,7865.2 c 0,0 -4.53,-62.7 -4.67,-121.7 -111.39,3.2 -170.27,104.8 -194.4,161.1 l 199.07,-39.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path590",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6681.74,7809.3 c 0,0 -263.56,-4.3 -263.74,159.8 -0.18,164.2 -34.32,274.2 133.95,283.9 168.26,9.7 201.03,-52.9 214.42,-107.7 13.39,-54.7 -16.08,-330.6 -84.63,-336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path592",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7049.51,3983.2 -84.58,-20.8 c 0,0 -133,182.1 -243.55,430.6 -70.06,157.4 -131.02,337.2 -143.31,504.2 -5.57,75.7 -1.17,148.7 16.88,215.9 0,0 -23.66,158.9 -55.98,371 -35.89,235.7 -82.44,537.1 -118.92,758.8 l 22.02,6.5 359.82,210.4 c 0,0 165.35,-376.9 123.11,-943.5 -8.66,-116.3 16.13,-296.2 -5.84,-428.3 -37.49,-225.9 -22.06,-453 9.05,-642 44.56,-270.3 121.3,-462.8 121.3,-462.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path594",
    style: {
      fill: "#cb7d45",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6180.31,6986.5 c 49.39,-136.4 74.82,-192.1 73.6,-243.6 157.44,243.7 441.83,280.5 441.83,280.5 l -540.03,61.7 c 4.94,-33.4 12.97,-66.4 24.6,-98.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path596",
    style: {
      fill: "#b64c41",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6758.53,8236.6 c -40.67,49.3 -71.43,38.6 -88.69,23.8 -141.31,78.4 -236.97,-38 -236.97,-38 -17.63,-117.8 -102.57,-185.3 -102.57,-185.3 0,0 46.92,-24.9 158.78,-1.1 132.76,28.1 169.28,177.7 174.58,197.2 16.09,-14.5 47.8,-45.8 57.47,-76.6 13.14,-41.8 19.05,-127.9 44.13,-124.9 0,0 54.37,130.9 -6.73,204.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path598",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5778.56,6204.8 c 0,0 -24.05,-56.7 -49.1,-72.5 -25.05,-15.9 -60.64,-54.1 -54.04,-84.4 6.58,-30.3 13.17,-77.8 44.81,-77.8 31.64,0 105.46,139.8 114.69,166.1 9.23,26.4 17.14,31.7 17.14,31.7 l -73.5,36.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path600",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 7020.41,4958.8 C 6702.17,4777 5864.4,5066.6 5865.26,5083.3 c 4.43,89 84.95,624.8 179.5,1136.1 58.11,314.4 212.86,431.8 188.11,451.7 l -0.37,0.3 c -95.41,67.8 -54.17,184 -47.89,225.6 -29.3,-7.9 -123.85,-25.8 -232.06,34 44.56,217.9 108.09,523.4 171.74,644.4 3.07,6 8.37,11.4 15.63,16.5 l -0.61,0.8 c 59.58,43.4 181.34,56.7 181.34,56.7 0,0 65.62,-160.6 85.68,-185.7 129.89,-162.3 363.18,-89 331.42,12 -11.45,36.8 -70.42,152.7 -77.56,165.6 l 16.5,-1.6 c 39.14,-5.2 66.85,-9.1 86.79,-12.5 39.15,-6.7 48.87,-11.4 58.6,-18.9 34.35,-34.3 79.04,-119.6 82.61,-271.9 1.35,-56.7 60.32,-681.9 -130.5,-671.1 -4.31,0.2 -0.62,-10 7.63,-29.3 26.96,-61.9 103.41,-217.3 125.58,-416.6 72.14,-648.4 113.01,-1260.6 113.01,-1260.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path602",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6606.01,7906.2 c 0,0 5.02,-20.2 55.4,-16.5 0,0 42.3,3.2 40.74,25.4 0,0 -41.24,15.4 -96.14,-8.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path604",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5834.92,6136.2 c 0,0 -8.65,-63.8 -25.46,-78.5 -16.82,-14.7 -19.27,-41.2 -36.51,-26.9 -17.23,14.2 61.97,105.4 61.97,105.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path606",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6895.77,3873.2 c 0.08,-47.8 67.17,-53.2 143.98,-49.8 76.81,3.4 55.18,-14.4 161.73,-23.6 106.56,-9.1 145.85,23.5 152.1,38.4 5.58,13.2 -44.98,28.2 -98.98,45.6 -6.79,2.1 -13.6,4.4 -20.41,6.6 -60.84,20.2 -98.55,69.5 -148.66,113.8 -47.47,42 -102.27,185.5 -102.27,185.5 l -145.24,17 c 0,0 52.43,-128.8 71.63,-184.1 11.29,-32.6 2.75,-70.9 -5.28,-100.3 -4.32,-15.9 -8.65,-32.3 -8.6,-49.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path608",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7039.75,3823.4 c 76.81,3.4 55.18,-14.4 161.73,-23.6 106.56,-9.1 145.85,23.5 152.1,38.4 5.58,13.2 -44.98,28.2 -98.98,45.6 l -0.72,-1 c 0,0 -71.32,-31.9 -158.52,-16.8 -71.08,12.3 -141.99,47.4 -190.99,56.3 -4.32,-15.9 -8.65,-32.3 -8.6,-49.1 0.08,-47.8 67.17,-53.2 143.98,-49.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path610",
    style: {
      fill: "#35488b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 7020.41,4958.8 C 6702.17,4777 5864.4,5066.6 5865.26,5083.3 c 4.43,89 84.95,624.8 179.5,1136.1 58.11,314.4 212.86,431.8 188.11,451.7 5.91,-4.8 95.66,-77.2 260.26,-67.4 147.36,8.9 260.87,27.4 288.69,32.3 26.96,-61.9 103.41,-217.3 125.58,-416.6 72.14,-648.4 113.01,-1260.6 113.01,-1260.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path612",
    style: {
      fill: "#22356b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6232.5,6671.4 c 0,0 260.59,-108.7 541.69,-6.1 l 14.27,-44.1 c 0,0 -289.18,-100.4 -567.22,13.9 l 11.26,36.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path614",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5346.13,6144.4 c 0,0 243.93,-497.3 214.29,-535 -29.65,-37.6 -238.02,135.9 -284.32,252.7 -46.3,116.9 70.03,282.3 70.03,282.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path616",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5684.8,6033.7 c 0,0 -147.35,-212.2 -212.97,-307.9 -36.02,-52.6 57.15,-120.6 88.59,-116.4 31.43,4.3 150.94,338.6 150.94,338.6 l -26.56,85.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path618",
    style: {
      fill: "#35488b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4901.14,6024.1 c 0,0 -193.71,85.2 -340.28,10.7 -146.57,-74.6 -56.96,-689.8 152.62,-749.5 0,0 392.64,-121.3 187.66,738.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path620",
    style: {
      fill: "#2c3a64",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5560.01,3986.9 c 0,0 30.48,-35.1 79.46,-34.6 30.24,0.4 58.38,-8.5 78.86,-25.1 18.14,-14.7 10.73,-43.2 -12.36,-48.4 l -231.24,-51.2 c -22.25,-4.9 -44.06,9.8 -46.94,31.7 -2.17,16.4 -4.8,34.8 -7.38,49 -6.09,33.4 21.85,67.6 21.85,67.6 l 117.75,11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path622",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5442.31,3975.9 c 0,0 -0.66,3 -1.88,8.5 -15.18,66.8 -116.64,510.4 -140.67,542.5 -6.21,8.1 -51.5,105.4 -67.68,133.5 -0.77,1.5 -111.76,481.4 -97.69,517.5 16.28,41.3 237.04,38.2 238.14,33.7 4.65,-18.1 11.08,-43.1 18.72,-72.8 0.88,-3.7 1.88,-7.5 2.88,-11.3 43.2,-169.9 119.96,-472.2 131.59,-523.7 13.62,-60.5 28.46,-451.4 33.01,-577.7 0.88,-24.7 1.32,-39.3 1.32,-39.3 l 0.22,-0.3 c 1,-1.9 2.11,-13.5 -117.96,-10.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path624",
    style: {
      fill: "#b64c41",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5590.18,4048.9 c 0,0 -40.15,-27.4 -101.07,-38.1 -85.84,-15.1 -122.53,8.7 -122.53,8.7 0,0 -63.5,360.9 -104.04,484.3 -9.97,30.1 -28.68,72.9 -51.5,120.6 l -1.11,2.5 c -13.51,27.9 -28.25,57.5 -43.42,87.1 -29.13,57.1 -59.92,114.5 -85.51,161.6 -7.09,13 -13.73,25.2 -19.94,36.4 -23.7,43.2 -39.65,71.3 -39.65,71.3 l 57.82,60.8 16.61,17.6 117.52,123.6 50.07,52.5 35.67,37.6 3.65,3.8 49.62,52.3 c 0,0 11.52,-38.6 28.91,-98.5 47.74,-164.5 140.45,-490.6 163.71,-625.7 23.7,-138.2 45.19,-558.4 45.19,-558.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path626",
    style: {
      fill: "#91322d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5269.85,5133.5 -1.99,-17.4 -57.93,-489.2 c -13.51,27.9 -28.25,57.5 -43.42,87.1 l -8.75,-34.4 -8.75,-34.8 c -25.59,57.4 -50.95,120.6 -68.34,166.5 v 0.1 c -11.3,29.4 -19.27,51.6 -21.93,60.7 -0.33,1.1 -0.56,1.9 -0.78,2.6 -1.22,4.8 -0.11,18.2 3.1,37.3 3.66,23 10.19,54.4 18.94,89.4 v 0.1 c 4.66,19.3 9.98,39.5 15.84,60.2 11.3,39.4 24.48,80.1 38.55,116.2 16.28,41.3 33.67,76.7 51.4,98 12.4,15.2 25.03,23.3 37.1,21.2 12.18,-2 21.05,-9.1 27.36,-19.3 6.76,-10.7 10.74,-24.7 13.18,-40 2.33,-14.3 3.21,-29.8 3.65,-44.5 0.67,-25.7 0,-49 2.77,-59.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path628",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5209.72,6161.2 -199,-98.3 -39.88,133.4 c 0,0 25.36,46.2 36.83,121.8 4.79,31.8 7.17,68.8 4.11,109.8 l 162.14,-80.2 c 0,0 -3.87,-14.5 -6.45,-35.9 -2.76,-23.1 -4,-54.3 2.8,-83.8 5.86,-25.4 17.62,-49.7 39.45,-66.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path630",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4874.79,5203.1 c 0,0 -79.66,-482.4 -71.24,-1254.7 l 112.69,-14.1 c 0,0 89.7,298.8 146.25,596.5 33.44,176 11.47,690.3 11.47,690.3 l -199.17,-18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path632",
    style: {
      fill: "#b64c41",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5308.96,5279.5 -1.89,-7.3 -18.83,-74.8 -20.38,-81.3 -101.35,-402.1 -8.75,-34.4 -8.75,-34.8 -161.57,-663.7 c 0,0 -30.83,-4.9 -59.07,-4.4 -97.84,1.7 -160.61,33 -160.61,33 0,0 -7.2,919.8 -4.32,1182.4 0.45,37.7 0.67,63.2 0.56,71.8 l 421.79,12 64.46,1.9 39.65,1.1 12.85,0.3 6.21,0.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path634",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5335.92,5208.3 c -221.36,-58.1 -503.7,-25.5 -573.25,-16.1 -10.39,1.4 -16.02,2.3 -16.02,2.3 -24.48,5.7 -41.13,26.9 -41.13,50.4 0,3 0.31,6.1 0.87,9.2 l 65.61,352.1 -22.03,176.7 -12.53,100.8 -28.61,230.1 c 94.78,46.6 180.99,71.5 259.99,82.5 30.24,-30 89.96,-74 156.76,-65.6 50.21,6.4 61.6,31.6 60.72,59.2 104.98,-16.7 159.83,-45.5 159.83,-45.5 l 68.24,-827.4 c 4.13,-49.7 -28.68,-95.6 -78.45,-108.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path636",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4968.82,6196.3 -29.89,-57.5 -29.05,-55.9 -140.43,-295.3 c -22.55,28.2 -186.41,84 -186.41,84 0,0 74.42,181.3 125.8,242.2 14.78,17.5 42.51,31.8 74.62,43.2 26.45,9.5 55.88,17 83.36,22.8 54.91,11.6 102,16.5 102,16.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path638",
    style: {
      fill: "#35488b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4711.06,5304.9 19.48,93.3 c 288.56,403.4 332.87,486 203.1,667.1 -37.16,51.9 -114.59,87.1 -142.16,94.5 26.46,9.4 63.06,17.3 90.54,23.1 27.39,-12.5 55.24,-27.8 74.77,-44.1 396.04,-331.3 -245.73,-833.9 -245.73,-833.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path640",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4906.04,5699.7 c 7.17,0.5 38.29,15.6 38.29,15.6 0,0 29.42,102.4 128.62,119.4 0,0 47.05,-0.3 37.4,-31.3 -9.66,-31.1 -10.67,-17.6 -23.27,-61.7 -12.6,-44.1 -45.41,-77.6 -80.36,-79.6 l -35.8,-9.4 c 0,0 -83.7,45.7 -64.88,47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path642",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4944.33,5715.3 c 0,0 -189.61,-16.6 -217.63,-28.7 0,0 15.39,40.2 42.75,101 -24.73,23.5 -105.98,58.5 -159.77,74.5 -41.04,-101.1 -56.8,-201.3 -33.79,-297.8 2.44,-10.2 11.71,-17.5 22.52,-18 60.68,-2.7 261.99,-1.7 408.2,117 l -62.28,52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path644",
    style: {
      fill: "#e8945b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5170.27,6228 c -92.19,2.3 -162.6,90.1 -162.6,90.1 l 159.8,-6.3 c -2.76,-23.1 -4,-54.3 2.8,-83.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path646",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5209.51,6268.4 c 0,0 -242.55,-28.6 -247.72,136.6 -5.17,165.1 95.92,272 163.4,270.8 134.56,-2.4 156.75,-55 172.35,-109.7 15.6,-54.7 23.63,-286.1 -88.03,-297.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path648",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5144.64,6363.6 c 0,0 5.28,-20.6 58.4,-16.8 0,0 44.6,3.1 42.96,25.8 0,0 -43.48,15.7 -101.36,-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path650",
    style: {
      fill: "#2c3a64",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4916.67,3935.6 c 0,0 20.75,-39.2 66.72,-48.8 28.96,-6.1 53.75,-20.7 69.18,-41.1 13.04,-17.3 0.42,-41.5 -21.69,-41.5 h -233.32 c -19.87,0 -35.38,16.5 -33.39,35.6 1.74,16.7 3.55,36.2 4.35,51.1 1.72,32.6 35.47,58.8 35.47,58.8 l 112.68,-14.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path652",
    style: {
      fill: "#35488b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5006.49,6310.8 c 0,0 -159.47,113.1 -159.47,247.9 0,167.2 106.53,212.8 255.24,221 148.71,8.1 254.43,-113.4 214.57,-176.2 -39.85,-62.8 -88.88,-47.9 -182.77,-37.7 -93.89,10.2 -89.95,-73.3 -129.87,-69.3 -39.91,4.1 -51.5,17.3 -54.66,-9.1 -3.16,-26.5 41.43,-35.1 33.73,-61.1 -14.44,-48.8 23.23,-115.5 23.23,-115.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path654",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5005.45,6484.3 c 0,0 -32.47,41.3 -54.61,30.6 -22.13,-10.7 -0.79,-71.8 15.82,-80.2 16.6,-8.4 34.91,-14.6 38.79,-10.7 3.89,3.8 0,60.3 0,60.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path656",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5346.13,6144.4 c 0,0 79.93,-67.9 133.17,-233.9 0,0 16.79,-162.5 -133.17,-177.9 -149.97,-15.4 0,411.8 0,411.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path658",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4944.33,5715.3 c 0,0 6.03,29.9 16.07,59.4 10.03,29.6 16.01,58.4 23.31,44.9 7.3,-13.4 9.96,-50.4 9.96,-50.4 l -49.34,-53.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path660",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5684.8,6007.7 c 0,0 30.1,119.4 104.45,114.6 74.36,-4.8 61.97,-77.4 26.56,-114.6 -35.41,-37.2 -107.06,-61.5 -107.06,-61.5 l -23.95,61.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path662",
    style: {
      fill: "#e8945b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7025.03,6199.4 c 0,0 28.75,-125.8 36.72,-116.5 7.97,9.3 7.97,58 7.97,58 l -44.69,58.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path664",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13053.2,7468.4 c 0,0 89.9,-15.7 107.6,-86.9 40.4,-161.7 26.6,-604.4 66.5,-741.7 40,-137.3 154.3,-479.1 171.4,-550.2 0,0 -46.8,-29.7 -74.2,-19 -16.3,6.3 -285.7,471.3 -314.3,540.1 -28.5,68.9 43,857.7 43,857.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path666",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12777.9,4448.4 c -23,-316.2 71.7,-539 71.7,-539 l 37.8,-38.5 c 0,0 77.5,212.4 150.1,468.5 69.1,243.4 150.7,499.5 206.8,572.4 222.4,289.4 474.3,1480 474.3,1480 l -510,111.7 c -66.3,-78.3 -112.8,-217.1 -145.3,-378.4 -82.2,-407 -75.4,-956.8 -74,-1036.4 l 0.1,-0.1 c 0.1,-6.2 -2.6,-11.8 -6.3,-16.7 -136.3,-185.4 -189.9,-414.7 -205.2,-623.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path668",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12777.9,4448.4 c -23,-316.2 71.7,-539 71.7,-539 l 37.2,-47.3 c 0,0 78.1,221.2 150.7,477.3 -30.8,2.9 -165.6,20.5 -259.6,109"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path670",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13167.5,6517 c 141,450.6 -13.5,548.6 1.2,774 14.7,225.5 189.3,467.9 189.3,467.9 0,0 8.9,0.9 23.9,2.3 11.7,6.2 14.9,55.2 14.7,106.9 -0.1,62.1 -4.9,128 -4.9,128 l 57,11.3 152.4,30.1 12.4,2.5 c -0.1,-34.6 1.9,-66.3 5.6,-95 6.5,-51.8 18,-93.4 30.6,-122.9 12.8,-30 26.9,-47.4 37.8,-50.3 99.4,-20.4 259.4,-319.5 218.3,-596.1 -5.2,-35.2 -13.6,-69.9 -25.9,-103.7 -51.9,-143.6 -78.6,-202 -77.4,-256.3 1.7,-68.6 48.2,-130.2 145.3,-348.2 53.7,-120.5 -924.2,-410.7 -780.3,49.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path672",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13404.9,4375.7 c 69.8,-277.4 174.8,-490.1 174.8,-490.1 l 91.4,6.4 c 0,0 -44.9,213.2 -42.3,501.3 1.8,201.5 26.7,439.5 106.3,666.8 273.5,781.2 229.3,1349.7 229.3,1349.7 l -514.3,-60.2 -24,-2.8 c -2.1,-236.2 -8.2,-556.9 -13.5,-807.7 -4.8,-225.5 -8.9,-394.5 -8.9,-394.5 -98.9,-213 -63,-513.6 1.2,-768.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path674",
    style: {
      fill: "#f9ddbf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14013.2,6310.1 c 0.9,-17.6 0,-31.6 -3.2,-41.7 -11.1,-34.9 -49.2,-50.8 -141.3,-41.3 -56.3,5.9 -81.4,100.3 -92.6,180.8 -33.9,-115.2 -81.2,-179.9 -142.4,-193.4 -89.3,-19.9 -539.8,-74.7 -569.3,139.5 -32.5,235.5 64.7,652.6 70,877.5 -13.2,79.7 -17.8,148.9 -16.3,208.4 3.7,160.1 50.7,249.9 86.9,286.1 10.2,7.8 20.5,12.7 61.6,19.8 21,3.6 50.1,7.7 91.3,13.1 l 16.5,1.3 c -7.6,-13.6 -109.7,-168.1 -101.7,-207.8 8.3,-41.6 370.2,-4.2 395.1,18.7 25,22.8 64.5,198 64.5,198 0,0 128.1,-14 190.8,-59.5 l -0.7,-0.9 c 7.6,-5.4 13.3,-11.2 16.5,-17.3 66.9,-127.3 133.7,-448.6 180.6,-677.9 -113.8,-62.7 -213.3,-44 -244.1,-35.7 40.3,-264 131.8,-547.4 137.8,-667.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path676",
    style: {
      fill: "#233862",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12819.1,3801.5 h 58.4 c 19.5,3.1 34,8.8 54,11.4 30.5,4 44.5,-8.5 47.3,-11.4 l 0.5,-0.5 h 247.9 c 6.2,8.9 0.2,29.5 -5.6,44.7 -4,10.3 -12.6,18.1 -23.2,21.2 -26.3,7.6 -78.1,14.4 -125.6,57.3 -26.7,24.2 -128.9,88.8 -128.9,88.8 l -0.6,0.1 c -2.2,-0.1 -12.9,-3.3 -59.4,-42.6 -24.1,-20.3 -65,28.6 -65,28.6 0,0 -7.7,-6.4 -13.5,-18.2 -4.6,-9.4 -7.9,-22.2 -5.3,-38.1 3.7,-22.3 -8.2,-63.8 -17.7,-91.9 -5.8,-17 -10.7,-29.1 -10.7,-29.1 0,0 -2.8,-14 47.4,-20.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path678",
    style: {
      fill: "#466aa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12805.4,3980.9 c 14,-9.8 43.4,-29.2 62.9,-31.7 26.3,-3.5 75.6,63.8 75.6,63.8 l -0.6,0.1 c -2.2,-0.1 -12.9,-3.3 -59.4,-42.6 -24.1,-20.3 -65,28.6 -65,28.6 0,0 -7.7,-6.4 -13.5,-18.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path680",
    style: {
      fill: "#466aa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12994.1,3817.1 c -11.4,8.4 -45.7,22.9 -93.6,11.5 -41.6,-10 -103,15.5 -118.1,22.3 -5.8,-17 -10.7,-29.1 -10.7,-29.1 0,0 -2.8,-14 47.4,-20.3 h 58.4 c 19.5,3.1 34,8.8 54,11.4 30.5,4 44.5,-8.5 47.3,-11.4 l 0.5,-0.5 h 247.9 c 6.2,8.9 0.2,29.5 -5.6,44.7 -7.5,6.7 -9.7,-29.1 -13.8,-34.8 l -213.7,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path682",
    style: {
      fill: "#233862",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13530.2,3801.5 h 58.4 c 19.5,3.1 34,8.8 54,11.4 30.5,4 44.5,-8.5 47.3,-11.4 l 0.5,-0.5 h 247.9 c 6.3,8.9 0.3,29.5 -5.6,44.7 -4,10.3 -12.6,18.1 -23.2,21.2 -26.3,7.6 -78.1,14.4 -125.6,57.3 -26.7,24.2 -128.9,88.8 -128.9,88.8 l -0.6,0.1 c -2.2,-0.1 -12.9,-3.3 -59.4,-42.6 -24,-20.3 -65,28.6 -65,28.6 0,0 -7.7,-6.4 -13.4,-18.2 -4.7,-9.4 -8,-22.2 -5.4,-38.1 3.7,-22.3 -8.2,-63.8 -17.7,-91.9 -5.8,-17 -10.7,-29.1 -10.7,-29.1 0,0 -2.8,-14 47.4,-20.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path684",
    style: {
      fill: "#466aa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13516.6,3980.9 c 13.9,-9.8 43.3,-29.2 62.8,-31.7 26.3,-3.5 75.6,63.8 75.6,63.8 l -0.6,0.1 c -2.2,-0.1 -12.9,-3.3 -59.4,-42.6 -24,-20.3 -65,28.6 -65,28.6 0,0 -7.7,-6.4 -13.4,-18.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path686",
    style: {
      fill: "#466aa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13705.2,3817.1 c -11.4,8.4 -45.7,22.9 -93.6,11.5 -41.6,-10 -102.9,15.5 -118.1,22.3 -5.8,-17 -10.7,-29.1 -10.7,-29.1 0,0 -2.8,-14 47.4,-20.3 h 58.4 c 19.5,3.1 34,8.8 54,11.4 30.5,4 44.5,-8.5 47.3,-11.4 l 0.5,-0.5 h 247.9 c 6.3,8.9 0.3,29.5 -5.6,44.7 -7.5,6.7 -9.7,-29.1 -13.8,-34.8 l -213.7,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path688",
    style: {
      fill: "#f9ddbf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13357.9,7758.9 c 0,0 -176.7,-13.8 -229.7,-60.1 -79.4,-69.4 -127.2,-615.5 -123.6,-630.5 3.6,-15 39.8,-69 135.7,-57 95.9,12 80.9,552.1 95.9,582.1 15,30 121.7,165.5 121.7,165.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path690",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14073.9,6035.3 -86.4,-8.5 c 0,0 -181.5,499.9 -183.1,621 -0.6,39.4 -5.3,119 -11.4,208.4 -12.8,185.1 -31.5,412.2 -31.5,412.2 l -3,91 -10.2,310.4 c 0,0 128.7,-39.2 199.1,-86.4 23.4,-15.6 40.3,-32.1 44.1,-48.3 32.1,-135.1 26.8,-459.3 22.5,-690.4 -2.4,-128.8 -4.6,-228.7 0.2,-250.9 13.3,-61.9 26.3,-390.9 59.7,-558.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path692",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14054.1,6069.8 c 0,0 73.8,-103.3 78.8,-139.3 5,-36 -19.1,-117.7 -25.1,-127.6 -6,-10 -49.3,43.5 -60,71.2 -10.6,27.7 -28,81.7 -32.8,57.3 -4.8,-24.4 -2.5,-52.2 -20.4,-40.7 -17.8,11.6 -4.3,156.4 -4.3,156.4 l 63.8,22.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path694",
    style: {
      fill: "#f9ddbf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14119.5,7013.5 c 0,0 -217.5,-116.6 -400.9,-32.3 -183.4,84.4 29.7,688.6 29.7,688.6 h 162.8 c 0,0 146.3,-140.1 208.4,-656.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path696",
    style: {
      fill: "#2c3a64",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 13502.2,8549.1 c 0,0 -235.7,30.7 -310.3,-215.5 -57,-188 -181,-287.4 -177.4,-486.1 3.5,-198.7 42.4,-198.7 -0.1,-305.1 -42.5,-106.5 60.4,-212.9 166.9,-212.9 106.4,0 636.4,168.8 655.2,268.9 18.9,100.1 -71.7,284.3 -39.8,359 32,74.7 -45.1,188.4 -26.5,347.8 11.2,95.3 -70.8,264.4 -268,243.9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.41085)",
    id: "g698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path700",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16068,5157.66 c 0,0 166.4,-3.26 178.3,-51.1 27.1,-108.52 -88.2,-413.02 -61.3,-505.23 26.8,-92.21 103.5,-321.58 115,-369.35 0,0 -31.4,-19.92 -49.8,-12.76 -10.9,4.25 -191.8,316.41 -211,362.62 -19.2,46.21 28.8,575.82 28.8,575.82"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.42807)",
    id: "g702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path704",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15958.3,3044.04 c 29.1,-208.18 124.6,-318.89 124.6,-318.89 l 26.8,-40.26 c 0,0 20.7,148.52 32.1,324.7 10.9,167.43 28.1,344.88 54.3,399.98 103.9,218.55 101.3,1025.73 101.3,1025.73 l -346.3,1.33 c -32,-59.95 -42.8,-156.44 -41.4,-265.54 3.4,-275.41 84.4,-630.92 96.5,-682.32 v -0.14 c 0.9,-3.99 -0.1,-7.98 -1.8,-11.69 -62.5,-139.21 -65.3,-295.3 -46.1,-432.9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.44629)",
    id: "g706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path708",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16120.9,3454.15 c 179.1,511.52 150.2,883.85 150.2,883.85 l -336.9,-39.41 -15.7,-1.87 c -1.3,-154.67 -5.4,-364.66 -8.8,-528.94 -3.1,-147.69 -5.8,-258.31 -5.8,-258.31 -64.8,-139.46 164.9,-204.18 217,-55.32"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.4304)",
    id: "g710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path712",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16080.6,3548.45 c 0,0 -185,-70.61 -259.8,-652.96 l 55.3,-24.05 423.9,621.08 -219.4,55.93"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.42926)",
    id: "g714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path716",
    style: {
      fill: "#233862",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16025.5,2661.31 h 38.6 c 13,2.03 22.5,5.81 35.8,7.49 20.2,2.66 29.5,-5.6 31.3,-7.49 l 0.4,-0.42 h 164.3 c 4.1,5.95 0.1,19.59 -3.8,29.67 -2.6,6.78 -8.3,11.96 -15.3,14.06 -17.4,5.04 -51.8,9.52 -83.3,37.99 -17.6,15.95 -85.4,58.78 -85.4,58.78 l -0.4,0.06 c -1.4,0 -8.5,-2.17 -39.4,-28.19 -15.9,-13.44 -43.1,18.96 -43.1,18.96 0,0 -5,-4.2 -8.8,-12.11 -3.1,-6.15 -5.3,-14.69 -3.5,-25.18 2.4,-14.84 -5.5,-42.33 -11.8,-60.94 -3.8,-11.27 -7.1,-19.24 -7.1,-19.24 0,0 -1.9,-9.31 31.5,-13.44"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.41243)",
    id: "g718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path720",
    style: {
      fill: "#466aa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16207.2,2813.24 c 9.3,-6.59 29.1,-19.54 42.1,-21.24 17.7,-2.27 50.7,42.76 50.7,42.76 l -0.4,0.07 c -1.4,0 -8.6,-2.19 -39.8,-28.53 -16.2,-13.59 -43.6,19.19 -43.6,19.19 0,0 -5.1,-4.25 -9,-12.25"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.42926)",
    id: "g722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path724",
    style: {
      fill: "#466aa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16292.1,2690.56 c -5,4.41 -6.4,-19.31 -9.1,-23.09 l -141.6,4.13 c -7.6,5.52 -30.3,15.18 -62,7.62 -27.6,-6.57 -68.3,10.29 -78.4,14.77 -3.7,-11.27 -7,-19.24 -7,-19.24 0,0 -1.9,-9.31 31.5,-13.44 h 38.6 c 13,2.03 22.5,5.81 35.8,7.49 20.2,2.66 29.5,-5.6 31.3,-7.49 l 0.4,-0.42 h 164.3 c 4.1,5.95 0.1,19.59 -3.8,29.67"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.39952)",
    id: "g726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path728",
    style: {
      fill: "#233862",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16082.2,2910.57 28.2,-27.8 c 10.8,-7.79 20.5,-11.93 31.3,-20.22 16.6,-12.57 17.4,-25.22 17.4,-27.94 v -0.5 l 119.3,-117.97 c 7.2,1.36 14.2,14.15 18.6,24.22 3,6.87 2.6,14.73 -1.1,21.3 -9,16.15 -30.8,44.01 -33.2,87.31 -1.4,24.3 -19.9,104.04 -19.9,104.04 l -0.2,0.28 c -1,1.08 -7.8,4.58 -48.9,7.79 -21.1,1.65 -17.6,44.73 -17.6,44.73 0,0 -6.7,0.57 -15.1,-2.43 -6.7,-2.28 -14.5,-6.86 -20.7,-15.79 -8.9,-12.5 -34.4,-26.79 -52.3,-35.79 -10.9,-5.44 -18.9,-8.94 -18.9,-8.94 0,0 -8,-5.43 13.1,-32.29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.39461)",
    id: "g730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path732",
    style: {
      fill: "#466aa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16217.8,3013.95 c 2.1,-11.4 7.1,-34.77 15.2,-45.31 11.1,-14.2 67,-5.24 67,-5.24 l -0.2,0.29 c -1.1,1.07 -7.8,4.59 -49.1,7.82 -21.2,1.65 -17.7,44.88 -17.7,44.88 0,0 -6.7,0.57 -15.2,-2.44"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.39926)",
    id: "g734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path736",
    style: {
      fill: "#466aa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16276.8,2730.72 -99.9,104.63 c -1.5,9.43 -11.2,32.8 -39.6,50.03 -24.8,15 -42.2,56.45 -46.3,66.96 -10.9,-5.43 -19,-8.93 -19,-8.93 0,0 -8,-5.44 13.2,-32.31 l 28.1,-27.8 c 10.9,-7.79 20.5,-11.93 31.4,-20.22 16.6,-12.58 17.4,-25.23 17.4,-27.95 v -0.49 l 119.3,-118 c 7.2,1.36 14.2,14.15 18.6,24.23 -0.4,6.79 -18.5,-9.43 -23.2,-10.15"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.44539)",
    id: "g738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path740",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15718.9,4281.42 c 39.2,320.95 9.6,510.24 19.2,658.02 9.7,147.71 145.7,285.32 145.7,285.32 0,0 5.9,0.56 15.7,1.46 7.7,4.08 9.7,36.18 9.7,70.08 -0.2,40.68 -3.3,83.85 -3.3,83.85 l 37.4,7.41 99.8,19.71 8.2,1.66 c -0.1,-22.69 1.2,-43.51 3.6,-62.26 4.3,-33.97 11.8,-61.23 20.1,-80.53 8.4,-19.65 17.6,-31.07 24.8,-32.94 65.2,-13.42 169.9,-209.35 143,-390.62 -3.4,-23.04 -8.9,-45.87 -16.9,-67.94 -34,-94.09 -51.6,-132.42 -50.8,-167.98 1.1,-44.9 26,-204.79 89.7,-347.66 35.2,-78.87 -560.9,-100.87 -545.9,22.42"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.40848)",
    id: "g742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path744",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,5361.65 c 0,0 -118.9,-9.3 -154.5,-40.47 -53.4,-46.65 -85.5,-413.85 -83.1,-423.93 2.4,-10.08 26.7,-46.43 91.2,-38.34 64.5,8.02 54.5,371.25 64.5,391.41 10.1,20.17 81.9,111.33 81.9,111.33"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.45009)",
    id: "g746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path748",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,4082.03 -56.5,-5.51 c 0,0 -118.5,326.46 -119.6,405.56 -0.3,25.72 -3.4,77.72 -7.4,136.13 -8.3,120.89 -20.6,269.22 -20.6,269.22 l -2,59.45 -6.6,202.75 c 0,0 84,-25.66 130.1,-56.48 15.2,-10.21 26.3,-20.97 28.8,-31.52 20.9,-88.27 17.5,-299.98 14.6,-450.94 -1.5,-84.13 -2.9,-149.37 0.2,-163.85 8.7,-40.48 17.1,-255.29 39,-364.81"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.4538)",
    id: "g750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path752",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16245.4,4094.09 c 0,0 48.1,-67.27 51.3,-90.8 3.3,-23.46 -12.5,-76.62 -16.3,-83.09 -3.9,-6.54 -32.2,28.34 -39.1,46.36 -6.9,18.09 -18.3,53.24 -21.4,37.35 -3.1,-15.89 -1.6,-34.05 -13.2,-26.48 -11.7,7.5 -2.9,101.87 -2.9,101.87 l 41.6,14.79"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.45274)",
    id: "g754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path756",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,4712.35 c 0,0 -141.9,-76.06 -261.4,-21.07 -119.6,55.01 19.4,448.95 19.4,448.95 h 106.1 c 0,0 95.4,-91.41 135.9,-427.88"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.43739)",
    id: "g758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path760",
    style: {
      fill: "#2c3a64",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16067.3,5774.44 c 0,0 -155.3,20.24 -204.5,-141.92 -37.5,-123.91 -119.2,-189.38 -116.9,-320.31 2.3,-130.93 28,-130.93 0,-201.06 -28.1,-70.13 6.2,-205.44 71.4,-231.18 438.2,-173.16 457.9,202.17 470.2,268.05 12.5,66.03 -47.2,187.36 -26.2,236.54 21.1,49.26 -29.7,124.19 -17.4,229.24 7.3,62.75 -46.7,174.14 -176.6,160.64"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.52098)",
    id: "g762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path764",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15966.1,2631.85 c 0,0 8.8,-135.76 35,-137.67 3.6,-0.26 133.3,0 133.3,0 l 165.6,1.31 c 0,0 -1.2,39.91 -49.6,48.26 -48.4,8.35 -129.5,42.21 -159,106.12 -31,67.26 -125.3,-18.02 -125.3,-18.02"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.47196)",
    id: "g766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path768",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15955,2718.61 c 0,0 9,-140.29 36.2,-142.19 3.6,-0.27 137.7,0 137.7,0 l 171.1,1.36 c 0,0 -1.2,41.24 -51.3,49.87 -50,8.63 -133.8,43.61 -164.3,109.65 -32,69.5 -129.4,-18.69 -129.4,-18.69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.48031)",
    id: "g770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path772",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,4231.49 c 0,0 -21.8,-287.31 -147.1,-804.23 -125.4,-516.92 -130.5,-736.87 -130.5,-736.87 l -178,-9.19 c 0,0 -45.4,550.43 10.7,809.83 56.1,259.34 -56.3,914.54 -56.3,914.54 l 501.2,-174.08"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.50382)",
    id: "g774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path776",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16130.8,4363.3 c 0,0 77.2,-415.21 92.5,-938.61 15.3,-523.34 76.7,-736.13 76.7,-736.13 l -171.5,-35.18 c 0,0 -190.4,493.61 -204.5,754.48 -14.2,260.87 -291.2,853.7 -291.2,853.7 l 498,101.74"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.47664)",
    id: "g778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path780",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16067.7,5418.5 95.1,-62.03 137.2,25.87 c -1.9,11.04 -11.1,56.95 -19.4,98.53 -0.5,2.44 -1.1,4.88 -1.5,7.25 -7.1,35.42 -13.3,65.76 -13.3,65.76 l -128.3,56.27 -47.8,21 c 0.1,-0.75 3.7,-39.28 4.3,-44.9 9.1,-99.82 -26.3,-167.75 -26.3,-167.75"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.47843)",
    id: "g782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path784",
    style: {
      fill: "#9b322d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16245.1,5443.75 c -2.7,1.08 -165.2,48.7 -182.8,42.82 -17.6,-5.89 -28,-40.05 -28,-40.05 l 265.7,-59.45 c 0,0 -21,42.47 -54.9,56.68"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.49002)",
    id: "g786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path788",
    style: {
      fill: "#b84c42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16286.2,4294.36 c -29.2,-28.32 -79.5,-48.66 -138.9,-61.34 -37.8,-8.06 -79.2,-13.02 -121.3,-14.97 -156.9,-7.18 -322.6,27.65 -338.9,101.34 -27.6,124.5 22.4,1025.56 222.4,1084.75 41.5,12.35 263.7,-58.93 263.7,-58.93 0,0 35.1,-91.07 58.1,-207.11 10.8,-54.36 19,-114.29 19.7,-172.95 1.5,-121.47 33.6,-359.05 43.8,-516.97 5.2,-80.87 4.7,-140.87 -8.6,-153.82"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.47488)",
    id: "g790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path792",
    style: {
      fill: "#fca56b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16122.8,5591.15 c 28.3,-47.66 133.4,-88.68 177.2,-103.73 -0.5,2.44 -1,4.88 -1.5,7.25 -7.1,35.46 -13.3,65.84 -13.3,65.84 l -128.5,56.34 c -28.3,0.34 -45.5,-6.03 -33.9,-25.7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.48269)",
    id: "g794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path796",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16247.5,5539.11 c 0,0 -205.5,-64.61 -243.7,64 -38.3,128.55 -90.5,206.79 39,253.46 129.6,46.67 169.8,5.26 193,-34.53 23.2,-39.86 64.2,-262.83 11.7,-282.93"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.48703)",
    id: "g798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path800",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16189.2,5817.37 c 0,0 -12.8,-149.3 -43.7,-142.91 -30.8,6.46 -58.9,11.17 -54.2,-33.82 4.6,-44.99 -57.9,-117.01 -103.9,-122.46 -63,-7.47 -168.6,191.86 -146.4,279.82 37.7,149.09 459,233.48 348.2,19.37"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.48696)",
    id: "g802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path804",
    style: {
      fill: "#1c468a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,4248.39 c 0,0 -76.7,-73.77 -180.1,-103.09 -103.4,-29.33 37.9,-159.05 90.7,-148.9 52.7,10.16 82.8,60.66 82.8,60.66 l 6.6,191.33"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.48338)",
    id: "g806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path808",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16222.2,4206.2 c 0,0 8.2,-45.5 21.7,-37.88 13.5,7.55 56.1,40.11 52.3,51.17 -3.8,10.98 -74,-13.29 -74,-13.29"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.48699)",
    id: "g810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path812",
    style: {
      fill: "#163560",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16034.2,4116.02 -0.4,15.27 c 179.6,5.04 265.5,129.86 266.2,131.07 l -0.7,-24.01 c -3.3,-5.18 -77.6,-117.08 -265.1,-122.33"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.47607)",
    id: "g814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path816",
    style: {
      fill: "#aa3e39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,4273.04 c -38.1,-8.13 -79.9,-13.14 -122.5,-15.11 -122.7,245.32 -71.3,680.26 -71.3,680.26 l 193.8,-665.15"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.48255)",
    id: "g818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path820",
    style: {
      fill: "#ffb27d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,4224.13 -68.7,-15.58 c 0,0 -65.3,137.81 -120.6,275.95 -8.7,21.78 -17.2,43.5 -25.1,64.68 h 173.8 c 1.7,-12.21 3.4,-24.55 5.1,-36.96 19.5,-142.79 35.5,-288.09 35.5,-288.09"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.47932)",
    id: "g822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path824",
    style: {
      fill: "#b84c42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,4522.08 -154.1,-27.78 c -35.7,89.09 -67.5,178.32 -75.1,231.05 -19.6,134.86 19,568.98 56.3,591.42 37.4,22.31 124,16.29 124,16.29 0,0 6.3,-459.4 19.4,-582.16 5.2,-47.86 17,-137.29 29.5,-228.82"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.88729)",
    id: "g826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path828",
    style: {
      fill: "#2e3552",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 16281.7,1971.24 H 814.715 c -10.101,0 -18.355,8.27 -18.355,18.34 v 8.21 c 0,10.06 8.254,18.33 18.355,18.33 H 16281.7 c 10,0 18.3,-8.27 18.3,-18.33 v -8.21 c 0,-10.07 -8.3,-18.34 -18.3,-18.34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.6c62b2adbb7377f9c8eca3bbf62f585a.svg";
export { ForwardRef as ReactComponent };